import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import _Promise from "babel-runtime/core-js/promise";
import _defineProperty from "babel-runtime/helpers/defineProperty";
import _Object$keys from "babel-runtime/core-js/object/keys";
import _typeof from "babel-runtime/helpers/typeof";
import _Object$assign from "babel-runtime/core-js/object/assign";

import custService from "../../service/cust-service.js";
import oppService from "../../service/opp-service.js";
import stringConfig from "../../tools/stringConfig.js";
import dict from "../../tools/dict";

import smsService from "../../service/sms-service";
import csdcService from "../../service/csdc-service";
import date from "../../tools/date";
import org from "../../tools/org";
import { getCustAge } from "@/tools/util";
import ecifParamRelationship from "@/business/businessTools/ecif-param-relationship";

var isCardIdType = function isCardIdType(ID_TYPE, isNot0J) {
  return "00" === ID_TYPE || !isNot0J && "0J" === ID_TYPE;
};
var getIdCodeValidType = function getIdCodeValidType(idType) {
  idType = idType || "";
  var validType = "";
  if (_.isEqual(idType.charAt(0), "0")) {
    validType = isCardIdType(idType) ? "cardno[true]" : ["0i", "0j", "0b", "0c"].includes(idType) ? "hkg_mac_ctn_cardno[0,48]" : "numchar[0,48]";
  } else if (idType == "10") {
    validType = "code_fixed_len[18,24]";
  } else if (idType == "01") {
    validType = "numchar[0,48]";
  } else {
    validType = "length[0,48]";
  }
  return validType;
};

var bizPublicMethod = {
  getCustomerAllData: function getCustomerAllData(_this) {
    var customerAllData = {
      Code: "0",
      Data: []
    };
    var c = _this.$storage.getJsonLocal(_this.$definecfg.CUST_ALL_INFO);
    if (c) {
      c.BASIC_INFO && !c.BASIC_INFO.OTHER_CUST_NAME && (c.BASIC_INFO.OTHER_CUST_NAME = "");
      c.BASIC_INFO && !c.BASIC_INFO.OTHER_ID_CODE && (c.BASIC_INFO.OTHER_ID_CODE = "");
      c.BASIC_INFO && !c.BASIC_INFO.OTHER_ID_EXP_DATE && (c.BASIC_INFO.OTHER_ID_EXP_DATE = "");
      c.BASIC_INFO && !c.BASIC_INFO.OTHER_ID_TYPE && (c.BASIC_INFO.OTHER_ID_TYPE = "");
      customerAllData["Data"].push(c);
      _this.busiCode != "V0127" && _Object$assign(_this.oppBusiData, customerAllData.Data[0]);
    }
    return customerAllData && customerAllData.Data && customerAllData.Data[0].BASIC_INFO;
  },

  isChinese: function isChinese(_this) {
    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);

    return _.indexOf(["CHN", "CTN", "HKG", "MAC"], customerInfo.CITIZENSHIP) != -1;
  },

  is15To18CodeBool: function is15To18CodeBool(_this) {
    var newBaseForm = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0];
    if (_.trim(newBaseForm.FIELDS.ID_CODE.DEFAULT_VALUE).length === 18 && newBaseForm.FIELDS.ID_TYPE.DEFAULT_VALUE == "00") {
      return true;
    } else {
      return false;
    }
  },

  is15To18CodeFromCustInfoBool: function is15To18CodeFromCustInfoBool(_this) {
    var newBaseForm = this.getCustomerAllData(_this);
    if (_.trim(newBaseForm.ID_CODE).length === 18 && newBaseForm.ID_TYPE == "00") {
      return true;
    } else {
      return false;
    }
  },

  is15To18OrgInfoBool: function is15To18OrgInfoBool(_this) {
    var newBaseForm = this.getCustomerAllData(_this);
    if (_.trim(newBaseForm.ID_CODE).length === 15) {
      if (_this.groupDatas.CUST_BASIC_INFO.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_CODE.DEFAULT_VALUE.length == 18) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  runPoliceValidate: function runPoliceValidate(_this) {
    _this.loading = true;
    _this.loadingText = "正在进行身份核实";
    var tempObj = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS;
    if (_this.userType != "0" || tempObj.ID_TYPE.DEFAULT_VALUE != "00") {
      return true;
    }
    var that = this;

    var params = {
      ID_CODE: tempObj.ID_CODE.DEFAULT_VALUE,
      USER_NAME: tempObj.USER_FNAME.DEFAULT_VALUE || ""
    };
    var res = "";
    return custService.runPoliceValidate(params).then(function (resultData) {
      if (resultData.flag) {
        _this.oppBusiData.policeCheckFlag = resultData.flag;
        _this.oppBusiData.policeData = resultData.result;
      }
      return resultData.flag;
    }).catch(function (err) {
      consoleLog("公安联网校验失败：" + err);
      res = "false";
      return res;
    });
  },

  setBankInfoToBasicInfo: function setBankInfoToBasicInfo(_this) {
    if (_this.userType == "0") {
      _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.FULLNAME.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.USER_FNAME.DEFAULT_VALUE;
      _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDTYPE.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
    } else {
      if (_this.busiCode == "V0009") {
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.FULLNAME.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.USER_FNAME.DEFAULT_VALUE;
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDNO.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_CODE.DEFAULT_VALUE;
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDTYPE.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
      } else if (_this.busiCode == "V0011") {
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.FULLNAME.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.USER_FNAME.DEFAULT_VALUE;
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDNO.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_CODE.DEFAULT_VALUE;
        _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDTYPE.DEFAULT_VALUE = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_TYPE.DEFAULT_VALUE;
      }
    }
  },

  isSyncYMTFlag: function isSyncYMTFlag(_this, oldBaseForm, newBaseForm) {
    if (_this.userType == "0") {
      if (_this.busiCode == "V0019") {
        return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.MAIL_ZIP_CODE != newBaseForm.MAIL_ZIP_CODE.DEFAULT_VALUE || oldBaseForm.OCCU_TYPE != newBaseForm.OCCU_TYPE.DEFAULT_VALUE || oldBaseForm.EDUCATION != newBaseForm.EDUCATION.DEFAULT_VALUE || oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
      } else if (_this.busiCode == "V0049") {
        return oldBaseForm.CITIZENSHIP != newBaseForm.CITIZENSHIP.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.ID_TYPE2 != newBaseForm.FZ_ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE2 != newBaseForm.FZ_ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE2 != newBaseForm.FZ_ID_EXP_DATE.DEFAULT_VALUE || oldBaseForm.BIRTHDAY != newBaseForm.BIRTHDAY.DEFAULT_VALUE || oldBaseForm.SEX != newBaseForm.SEX.DEFAULT_VALUE || oldBaseForm.EDUCATION != newBaseForm.EDUCATION.DEFAULT_VALUE || oldBaseForm.NATIONALITY != newBaseForm.NATIONALITY.DEFAULT_VALUE || oldBaseForm.OCCU_TYPE != newBaseForm.OCCU_TYPE.DEFAULT_VALUE || oldBaseForm.FAX != newBaseForm.FAX || oldBaseForm.TEL != newBaseForm.TEL || oldBaseForm.MOBILE_TEL != newBaseForm.MOBILE_TEL || oldBaseForm.ADDRESS != newBaseForm.ADDRESS || oldBaseForm.EMAIL != newBaseForm.EMAIL || oldBaseForm.ZIP_CODE != newBaseForm.ZIP_CODE ? "1" : "0";
      } else {
        return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
      }
    } else if (_this.userType == "1" || _this.userType == "2") {
      if (_this.busiCode == "V0019") {
        return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.MAIL_ZIP_CODE != newBaseForm.MAIL_ZIP_CODE.DEFAULT_VALUE || oldBaseForm.OCCU_TYPE != newBaseForm.OCCU_TYPE.DEFAULT_VALUE || oldBaseForm.EDUCATION != newBaseForm.EDUCATION.DEFAULT_VALUE || oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
      } else if (_this.busiCode == "V0049") {
        return oldBaseForm.CITIZENSHIP != newBaseForm.CITIZENSHIP.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.ID_TYPE2 != newBaseForm.FZ_ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE2 != newBaseForm.FZ_ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE2 != newBaseForm.FZ_ID_EXP_DATE.DEFAULT_VALUE || oldBaseForm.BIRTHDAY != newBaseForm.BIRTHDAY.DEFAULT_VALUE || oldBaseForm.SEX != newBaseForm.SEX.DEFAULT_VALUE || oldBaseForm.EDUCATION != newBaseForm.EDUCATION.DEFAULT_VALUE || oldBaseForm.NATIONALITY != newBaseForm.NATIONALITY.DEFAULT_VALUE || oldBaseForm.OCCU_TYPE != newBaseForm.OCCU_TYPE.DEFAULT_VALUE || oldBaseForm.FAX != newBaseForm.FAX || oldBaseForm.TEL != newBaseForm.TEL || oldBaseForm.MOBILE_TEL != newBaseForm.MOBILE_TEL || oldBaseForm.ADDRESS != newBaseForm.ADDRESS || oldBaseForm.EMAIL != newBaseForm.EMAIL || oldBaseForm.ZIP_CODE != newBaseForm.ZIP_CODE ? "1" : "0";
      } else {
        return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
      }
    }
  },

  isSyncYMTFlagNoImp: function isSyncYMTFlagNoImp(_this, oldBaseForm, newBaseForm) {
    if (_this.userType == "0") {
      return newBaseForm.USER_FNAME && oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || newBaseForm.ID_CODE && oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || newBaseForm.ID_ADDR && oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || newBaseForm.ZIP_CODE && oldBaseForm.ZIP_CODE != newBaseForm.ZIP_CODE.DEFAULT_VALUE || newBaseForm.OCCU_TYPE && oldBaseForm.OCCU_TYPE != newBaseForm.OCCU_TYPE.DEFAULT_VALUE || newBaseForm.EDUCATION && oldBaseForm.EDUCATION != newBaseForm.EDUCATION.DEFAULT_VALUE || newBaseForm.NATIONALITY && oldBaseForm.NATIONALITY != newBaseForm.NATIONALITY.DEFAULT_VALUE || newBaseForm.SEX && oldBaseForm.SEX != newBaseForm.SEX.DEFAULT_VALUE || newBaseForm.CITIZENSHIP && oldBaseForm.CITIZENSHIP != newBaseForm.CITIZENSHIP.DEFAULT_VALUE || newBaseForm.BIRTHDAY && oldBaseForm.BIRTHDAY != newBaseForm.BIRTHDAY.DEFAULT_VALUE || newBaseForm.NATIVE_PLACE && oldBaseForm.NATIVE_PLACE != newBaseForm.NATIVE_PLACE.DEFAULT_VALUE || newBaseForm.MOBILE_TEL && oldBaseForm.MOBILE_TEL != newBaseForm.MOBILE_TEL.DEFAULT_VALUE || newBaseForm.EMAIL && oldBaseForm.EMAIL != newBaseForm.EMAIL.DEFAULT_VALUE || newBaseForm.ADDRESS && oldBaseForm.ADDRESS != newBaseForm.ADDRESS.DEFAULT_VALUE || newBaseForm.ID_BEG_DATE && oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || newBaseForm.FAX && oldBaseForm.FAX != newBaseForm.FAX.DEFAULT_VALUE || newBaseForm.TEL && oldBaseForm.TEL != newBaseForm.TEL.DEFAULT_VALUE || newBaseForm.ID_EXP_DATE && oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
    } else {
      return newBaseForm.USER_FNAME && oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || newBaseForm.ID_CODE && oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || newBaseForm.ID_TYPE && oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || newBaseForm.ID_ADDR && oldBaseForm.ID_ADDR != newBaseForm.ID_ADDR.DEFAULT_VALUE || newBaseForm.ID_BEG_DATE && oldBaseForm.ID_BEG_DATE != newBaseForm.ID_BEG_DATE.DEFAULT_VALUE || newBaseForm.ID_EXP_DATE && oldBaseForm.ID_EXP_DATE != newBaseForm.ID_EXP_DATE.DEFAULT_VALUE ? "1" : "0";
    }
  },

  getBaseRequestData: function getBaseRequestData(_this) {
    var customerInfo = this.getCustomerAllData(_this);
    var int_org = customerInfo && customerInfo.INT_ORG ? customerInfo.INT_ORG : "";
    var basedata = {
      "BUSI_CODE": _this.busiCode,
      "USER_TYPE": customerInfo != null ? customerInfo.USER_TYPE : _this.userType,
      "ID_TYPE": customerInfo != null ? customerInfo.ID_TYPE : _this.oppBusiData.ID_TYPE,
      "ID_CODE": customerInfo != null ? customerInfo.ID_CODE : _this.oppBusiData.ID_CODE,
      "CUST_CODE": customerInfo != null ? customerInfo.CUST_CODE : "",
      "CUST_FNAME": customerInfo != null ? customerInfo.USER_FNAME : _this.oppBusiData.CUST_FNAME,
      "CITIZENSHIP": customerInfo != null ? customerInfo.CITIZENSHIP : _this.oppBusiData.CITIZENSHIP,
      "SUBJECT_IDENTITY": customerInfo != null ? customerInfo.SUBJECT_IDENTITY : _this.oppBusiData.SUBJECT_IDENTITY,
      "INT_ORG": int_org,
      "ORG_CODE": int_org
    };
    return basedata;
  },

  getBlackListRequestData: function getBlackListRequestData(_this) {
    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
    var basedata = {
      "ID_TYPE": customerInfo != null ? customerInfo.ID_TYPE : _this.oppBusiData.ID_TYPE,
      "CITIZENSHIP": customerInfo != null ? customerInfo.CITIZENSHIP : _this.oppBusiData.CITIZENSHIP,
      "SUBJECT_IDENTITY": customerInfo != null ? customerInfo.SUBJECT_IDENTITY : _this.oppBusiData.SUBJECT_IDENTITY
    };
    return basedata;
  },

  hideRouteAndMoudle: function hideRouteAndMoudle(_this, routerName) {
    _this.$router.hideRoute(routerName);
    var pageIndex = -1;
    for (var i = 0; i < _this.$store.state.bizRouteTable.length; i++) {
      var r = _this.$store.state.bizRouteTable[i];
      if (r.name == routerName) {
        pageIndex = i;
        break;
      }
    }

    if (pageIndex > -1) {
      var routerObj = _this.$router.getRoute(pageIndex);

      if (routerObj.group && routerObj.modules.length) {
        _.forEach(routerObj.modules, function (moduleID) {
          _this.groupDatas[routerObj.group][moduleID][0].MODULE_CONTROL = "0";
        });
      }
    }
  },

  showRouteAndMoudle: function showRouteAndMoudle(_this, routerName) {
    _this.$router.showRoute(routerName);
    var pageIndex = -1;
    for (var i = 0; i < _this.$store.state.bizRouteTable.length; i++) {
      var r = _this.$store.state.bizRouteTable[i];
      if (r.name == routerName) {
        pageIndex = i;
        break;
      }
    }

    if (pageIndex > -1) {
      var routerObj = _this.$router.getRoute(pageIndex);

      if (routerObj.group && routerObj.modules.length) {
        _.forEach(routerObj.modules, function (moduleID) {
          _this.groupDatas[routerObj.group][moduleID][0].MODULE_CONTROL = "1";
        });
      }
    }
  },

  setModulesControl: function setModulesControl(mds, moduleContrl) {
    if (mds && mds.length) {
      mds.forEach(function (md) {
        md.MODULE_CONTROL = moduleContrl;
      });
    } else {
      consoleLog("设置模块不存在");
    }
  },

  hideRouteAndShowMoudle: function hideRouteAndShowMoudle(_this, routerName) {
    _this.$router.hideRoute(routerName);
    var pageIndex = -1;
    for (var i = 0; i < _this.$store.state.bizRouteTable.length; i++) {
      var r = _this.$store.state.bizRouteTable[i];
      if (r.name == routerName) {
        pageIndex = i;
        break;
      }
    }

    if (pageIndex > -1) {
      var routerObj = _this.$router.getRoute(pageIndex);

      if (routerObj.group && routerObj.modules.length) {
        _.forEach(routerObj.modules, function (moduleID) {
          _this.groupDatas[routerObj.group][moduleID][0].MODULE_CONTROL = "1";
        });
      }
    }
  },

  getCustRiskStatus: function getCustRiskStatus(_this) {
    var _this2 = this;

    if (_this.$syscfg.isQSJG(_this.$definecfg.QSJGDM_CONST.GUOXIN)) {
      var tempSurveySn = "";
      return oppService.getSysCommonParamsFromCacheObjs("CUST_MAIN_SURVEY_SN", "99").then(function (response) {
        if (response && response.length > 0) {
          var tempSurveySnArr = response.split(";");
          if (_this.userType == "0") {
            tempSurveySn = tempSurveySnArr[0];
          } else if (_this.userType == "1") {
            tempSurveySn = tempSurveySnArr[1];
          } else if (_this.userType == "2") {
            if (tempSurveySnArr.length > 2) {
              tempSurveySn = tempSurveySnArr[2];
            } else {
              tempSurveySn = tempSurveySnArr[1];
            }
          }
        }

        if (tempSurveySn) {
          var custAllInfo = _this2.getCustomerAllData(_this);
          return _this.$syscfg.K_Request("W0000102", {
            ID_TYPE: custAllInfo.ID_TYPE,
            USER_CODE: custAllInfo.CUST_CODE,
            SURVEY_SN: tempSurveySn,
            CUST_CODE: custAllInfo.CUST_CODE,
            INT_ORG: custAllInfo.INT_ORG,
            USER_ROLE: 1
          }).then(function (res) {
            var ratingData = res.Data && res.Data[0];
            return ratingData;
          });
        } else {
          return {};
        }
      });
    }
  },

  showPwdBox: function showPwdBox(_this, messageText, field, callBack) {
    var fieldId = field.FIELD_ID,
        fieldTitle = field.FIELD_TITLE;
    return _this.$prompt(fieldTitle, messageText, {
      customClass: "pwd-msgbox " + fieldId,
      showCancelButton: true,
      showClose: false,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPattern: /^\d{6}$/,
      inputType: "password",
      inputErrorMessage: "密码格式不正确，只能为六位数字",
      beforeClose: function beforeClose(action, instance, done) {
        if (action == "confirm") {
          if (instance.inputValue != field.DEFAULT_VALUE) {
            instance.editorErrorMessage = "两次输入不一致，请重新输入";
            return;
          }
        }
        done();
      }
    }).then(function (_ref) {
      var value = _ref.value;

      callBack && callBack(true, value);
    }).catch(function (action) {
      callBack && callBack(false, action);
    });
  },

  showReEnterBox: function showReEnterBox(_this, params, field, callBack) {
    var fieldId = field.FIELD_ID,
        fieldTitle = field.FIELD_TITLE;
    var inputPattern = params.inputPattern || "",
        inputType = params.inputType || "",
        inputErrorMessage = params.inputErrorMessage || "输入格式错误，请重新输入",
        messageText = params.messageText || "确认输入";
    return _this.$prompt(fieldTitle, messageText, {
      customClass: "reenter-msgbox " + fieldId,
      showCancelButton: true,
      showClose: false,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPattern: inputPattern,
      inputType: inputType,
      inputErrorMessage: inputErrorMessage,
      beforeClose: function beforeClose(action, instance, done) {
        if (action == "confirm") {
          if (instance.inputValue != field.DEFAULT_VALUE) {
            instance.editorErrorMessage = "两次输入不一致，请重新输入";
            return;
          }
        }
        done();
      }
    }).then(function (_ref2) {
      var value = _ref2.value;

      callBack && callBack(true, value);
    }).catch(function (action) {
      callBack && callBack(false, action);
    });
  },

  analyzeIDCard: function analyzeIDCard(IDCard) {
    var sexAndAge = {};

    var userCard = IDCard;

    if (!userCard) {
      return sexAndAge;
    }

    if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
      sexAndAge.sex = "0";
    } else {
      sexAndAge.sex = "1";
    }

    var yearBirth = userCard.substring(6, 10);
    var monthBirth = userCard.substring(10, 12);
    var dayBirth = userCard.substring(12, 14);
    sexAndAge.birthDay = yearBirth + monthBirth + dayBirth;

    var myDate = new Date();
    var monthNow = myDate.getMonth() + 1;
    var dayNow = myDate.getDate();
    var age = myDate.getFullYear() - yearBirth;
    if (monthNow < monthBirth || monthNow == monthBirth && dayNow < dayBirth) {
      age--;
    }

    sexAndAge.age = age;

    return sexAndAge;
  },

  saveCustInfoTosession: function saveCustInfoTosession(_this, key, value) {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
    if (!custInfo) {
      custInfo = {};
    }
    custInfo[key] = value;
    _this.$storage.setSession(_this.$definecfg.CUSTOMER_INFO, custInfo);
  },

  filterIdCode: function filterIdCode(_this, idTypefield, idCodeField, fieldData) {
    var idType = idTypefield.DEFAULT_VALUE;

    if (idType == "00") {
      idCodeField.VALID_TYPE = "cardno[true]|" + idCodeField.VALID_TYPE;
    } else if (idType == "10") {
      idCodeField.VALID_TYPE = "busino|" + idCodeField.VALID_TYPE;
    } else {
      idCodeField.VALID_TYPE = idCodeField.VALID_TYPE.replace("cardno[true]|", "").replace("|cardno[true]", "").replace("cardno", "").replace("busino|", "");
    }
  },
  by: function by(name) {
    return function (o, p) {
      var a = void 0,
          b = void 0;
      if ((typeof o === "undefined" ? "undefined" : _typeof(o)) === "object" && (typeof p === "undefined" ? "undefined" : _typeof(p)) === "object" && o && p) {
        a = o[name];
        b = p[name];
        if (a === b) {
          return 0;
        }
        a = parseInt(a);
        b = parseInt(b);
        return a < b ? -1 : 1;
      } else {
        throw "error";
      }
    };
  },

  showMsgBox: function showMsgBox(_this, messageText, confirmedAction, canceledAction, confirmButtonText, cancelButtonText) {
    var opts = {
      hasMask: true,
      messageText: _.isString(messageText) && messageText || "",
      confirmButtonText: _.isString(confirmButtonText) && confirmButtonText || "确定",
      cancelButtonText: _.isString(cancelButtonText) && cancelButtonText || "",
      confirmedAction: _.isFunction(confirmedAction) && confirmedAction,
      canceledAction: _.isFunction(canceledAction) && canceledAction,
      typeMessage: "warn",
      showMsgBox: true
    };
    if (!_.isString(messageText)) {
      opts = _Object$assign({}, opts, messageText);
    }
    _this.alert(opts);

    return false;
  },

  hideMsgBox: function hideMsgBox(_this) {
    _this.messageBoxProps = {
      hasMask: true,
      messageText: "sb",
      typeMessage: "warn",
      showMsgBox: false
    };
    return false;
  },

  getFieldObj: function getFieldObj(_this, keyStr) {
    if (!_this || !_this.groupDatas || _.isEmpty(_this.groupDatas)) {
      return {};
    }
    var oldObj = _this.groupDatas;
    var keyArr = keyStr.split(".") || [];
    var newObj = {};
    if (keyArr.length == 3) {
      var groupId = keyArr[0];
      var moduleId = keyArr[1];
      var fieldId = keyArr[2];
      newObj = oldObj[groupId] && oldObj[groupId][moduleId] && oldObj[groupId][moduleId][0] && oldObj[groupId][moduleId][0]["FIELDS"] && oldObj[groupId][moduleId][0]["FIELDS"][fieldId];
    }
    return newObj || {};
  },

  getModuleObj: function getModuleObj(_this, keyStr) {
    if (!_this || !_this.groupDatas || _.isEmpty(_this.groupDatas)) {
      return {};
    }
    var oldObj = _this.groupDatas;
    var keyArr = keyStr.split(".") || [];
    var newObj = {};
    if (keyArr.length == 2) {
      var groupId = keyArr[0];
      var moduleId = keyArr[1];
      newObj = oldObj[groupId] && oldObj[groupId][moduleId] && oldObj[groupId][moduleId][0] && oldObj[groupId][moduleId][0];
    }
    return newObj || {};
  },

  changeFieldError: function changeFieldError(field, correct, errMessage) {
    field.correct = correct;
    field.message = errMessage;
  },

  addOppBusiData: function addOppBusiData(_this, data) {
    _Object$keys(data).forEach(function (key) {
      _this.oppBusiData[key] = data[key];
    });
  },

  parseOppBusiData: function parseOppBusiData(_this) {
    for (var gk in _this.groupDatas) {
      for (var md in _this.groupDatas[gk]) {
        for (var fk in _this.oppBusiData) {
          if (fk in _this.groupDatas[gk][md][0].FIELDS) {
            if (stringConfig.isEmptyStr(_this.groupDatas[gk][md][0]["FIELDS"][fk]["DEFAULT_VALUE"])) {
              _this.groupDatas[gk][md][0]["FIELDS"][fk]["DEFAULT_VALUE"] = _this.oppBusiData[fk];
            }
          }
        }
      }
    }
  },

  transTaxInfoToArr: function transTaxInfoToArr(taxInfoObj) {
    var taxInfo = taxInfoObj || {},
        commonReason = "居民国(地区)不发放纳税人识别号:",
        otherReasonPrefix = "账户持有人未能取得纳税人识别号:",
        rtnArr = [];
    if (taxInfo.TAX_RESIDENT_TYPE && taxInfo.TAX_RESIDENT_TYPE != "1") {
      var mainKey = "CITIZENSHIP",
          arrKeys = _.chain(taxInfo).keys().filter(function (v) {
        return v.indexOf(mainKey) == 0;
      }).value();

      arrKeys = _.sortBy(arrKeys);
      _.each(arrKeys, function (key, i) {
        if (taxInfo[key]) {
          var index = key.replace(mainKey, "");
          var taxNo = taxInfo["TAXPAYER_IDNO" + index];
          var reasonVal = taxInfo["NO_TAXPAYERID_REASON" + index] && taxInfo["NO_TAXPAYERID_REASON" + index].replace(otherReasonPrefix, "");

          if (commonReason.includes(reasonVal)) {
            reasonVal = commonReason;
          }
          var obj = {
            TAX_ID: index || "0",
            CITIZENSHIP: taxInfo[key],
            HAS_TAXPAYER_IDNO: !taxNo ? "0" : "1",
            TAXPAYER_IDNO: taxNo,
            OPP_NO_TAXPAYERID_REASON: !taxNo ? reasonVal == commonReason ? "1" : "2" : "",
            NO_TAXPAYERID_REASON: reasonVal == commonReason ? "" : reasonVal };

          rtnArr.push(obj);
        }
      });
    }
    return rtnArr;
  },

  transTaxAssetInfoToObj: function transTaxAssetInfoToObj(taxInfoArr) {
    var itemKeys = ["PAYMENT_TYPE", "PAYMENT_CURR", "PAYMENT_ASSET", "PAYMENT_AMNT"],
        rtnObj = {};

    _.each(taxInfoArr, function (v) {
      v.PAYMENT_AMNT = v.PAYMENT_ASSET ? v.PAYMENT_ASSET + "&&" + v.PAYMENT_CURR : "";
    });

    _.each(taxInfoArr || [], function (taxInfo) {
      _.each(itemKeys, function (key) {
        rtnObj[key + taxInfo.TAX_ID] = taxInfo[key];
      });
    });

    return rtnObj;
  },

  transTaxInfoToObj: function transTaxInfoToObj(taxInfoArr) {
    var commonReason = "居民国(地区)不发放纳税人识别号",
        otherReasonPrefix = "账户持有人未能取得纳税人识别号:",
        itemKeys = ["CITIZENSHIP", "TAXPAYER_IDNO", "OPP_NO_TAXPAYERID_REASON", "NO_TAXPAYERID_REASON"],
        rtnObj = {};

    _.each(itemKeys || [], function (key) {
      _.each(taxInfoArr || [], function (taxInfo) {
        taxInfo[key] = taxInfo[key] || "";
        if (taxInfo.TAX_ID == "0") {
          rtnObj[key] = taxInfo[key];
        } else {
          rtnObj[key + taxInfo.TAX_ID] = taxInfo[key];
        }
      });
    });

    _.each(rtnObj, function (v, k) {
      if (k.indexOf("OPP_NO_TAXPAYERID_REASON") == 0 && v) {
        var key = k.replace("OPP_", ""),
            taxNo = rtnObj["TAXPAYER_IDNO" + k.replace("OPP_NO_TAXPAYERID_REASON", "")];

        rtnObj[key] = !taxNo ? v == "1" ? commonReason : otherReasonPrefix + rtnObj[key] : "";
      }
    });
    return rtnObj;
  },

  transTaxAssetInfoToArr: function transTaxAssetInfoToArr(taxInfoObj, userType) {
    var taxInfo = taxInfoObj || {},
        rtnArr = [];

    if (taxInfo.TAX_RESIDENT_TYPE && (taxInfo.TAX_RESIDENT_TYPE !== "1" || userType != "0" && ["1", "2"].indexOf(taxInfo.PASSIVE_NFE) != -1)) {
      var mainKey = "PAYMENT_TYPE",
          arrKeys = _.chain(taxInfo).keys().filter(function (v) {
        return v.indexOf(mainKey) === 0;
      }).value();

      arrKeys = _.sortBy(arrKeys);
      _.each(arrKeys, function (key) {
        if (taxInfo[key]) {
          var index = key.replace(mainKey, ""),
              PAYMENT_AMNT = taxInfo["PAYMENT_AMNT" + index] ? taxInfo["PAYMENT_AMNT" + index].split("&&") : [],
              obj = {
            TAX_ID: index || "0",
            PAYMENT_TYPE: taxInfo["PAYMENT_TYPE" + index],
            PAYMENT_CURR: taxInfo["PAYMENT_CURR" + index] || (PAYMENT_AMNT.length > 1 ? PAYMENT_AMNT[1] : ""),
            PAYMENT_ASSET: taxInfo["PAYMENT_ASSET" + index] || (PAYMENT_AMNT.length > 0 ? PAYMENT_AMNT[0] : "")
          };
          rtnArr.push(obj);
        }
      });
    }
    return rtnArr;
  },

  getEmptyTaxCountry: function getEmptyTaxCountry() {
    return {
      CITIZENSHIP: "",
      CITIZENSHIP2: "",
      CITIZENSHIP3: "",
      TAXPAYER_IDNO: "",
      TAXPAYER_IDNO2: "",
      TAXPAYER_IDNO3: "",
      NO_TAXPAYERID_REASON: "",
      NO_TAXPAYERID_REASON2: "",
      NO_TAXPAYERID_REASON3: ""
    };
  },

  getEmptyTaxAsset: function getEmptyTaxAsset() {
    return {
      PAYMENT_TYPE1: "",
      PAYMENT_TYPE2: "",
      PAYMENT_TYPE3: "",
      PAYMENT_TYPE4: "",
      PAYMENT_CURR1: "",
      PAYMENT_CURR2: "",
      PAYMENT_CURR3: "",
      PAYMENT_CURR4: "",
      PAYMENT_ASSET1: "",
      PAYMENT_ASSET2: "",
      PAYMENT_ASSET3: "",
      PAYMENT_ASSET4: ""
    };
  },

  parseTaxWithTaxPayerData: function parseTaxWithTaxPayerData(_this, groupId, moduleId, taxInfo) {
    var bdata = {};
    if (taxInfo) {
      bdata[groupId] = {};
      bdata[groupId][moduleId] = this.transTaxInfoToArr(taxInfo);
      this.parseOldBiz(_this.groupDatas, bdata);
    }
  },

  parseTaxWithPayMentTaxData: function parseTaxWithPayMentTaxData(_this, groupId, moduleId, taxInfo) {
    var bdata = {};
    if (taxInfo) {
      bdata[groupId] = {};
      bdata[groupId][moduleId] = this.transTaxAssetInfoToArr(taxInfo, "0");
      if (bdata[groupId][moduleId].length == 0) {
        bdata[groupId][moduleId].push({});
      }
      this.parseOldBiz(_this.groupDatas, bdata);
    }
  },

  parseGroupsMouduleDataSource: function parseGroupsMouduleDataSource(_this, mouduleArr) {
    var oppData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (_.isString(mouduleArr)) {
      mouduleArr = [mouduleArr];
    }
    for (var gk in _this.groupDatas) {
      for (var md in _this.groupDatas[gk]) {
        if (_.indexOf(mouduleArr, md) != -1) {
          for (var fk in oppData) {
            if (fk in _this.groupDatas[gk][md][0].FIELDS) {
              _this.groupDatas[gk][md][0]["FIELDS"][fk]["DATA_SOURCE"] = oppData[fk + "_DATA_SOURCE"];
              _this.groupDatas[gk][md][0]["FIELDS"][fk]["UPDATE_FLAG"] && (_this.groupDatas[gk][md][0]["FIELDS"][fk]["UPDATE_FLAG"] = oppData[fk + "_UPDATE_FLAG"]);
            }
          }
        }
      }
    }
  },

  parseGroupsMouduleData: function parseGroupsMouduleData(_this, mouduleArr) {
    var oppData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var correct = arguments[3];

    if (_.isString(mouduleArr)) {
      mouduleArr = [mouduleArr];
    }
    correct = correct || false;
    for (var gk in _this.groupDatas) {
      for (var md in _this.groupDatas[gk]) {
        if (_.indexOf(mouduleArr, md) != -1) {
          for (var fk in oppData) {
            if (fk in _this.groupDatas[gk][md][0].FIELDS) {
              _this.groupDatas[gk][md][0]["FIELDS"][fk]["DEFAULT_VALUE"] = oppData[fk];
              if (correct) {
                _this.groupDatas[gk][md][0]["FIELDS"][fk]["correct"] = oppData["correct_" + fk];
                if (typeof oppData["correct_" + fk] == "string" && oppData["correct_" + fk] == "true" || typeof oppData["correct_" + fk] == "boolean" && oppData["correct_" + fk]) {
                  _this.groupDatas[gk][md][0]["FIELDS"][fk]["message"] = "";
                }
              }

              if (_this.groupDatas[gk][md][0]["FIELDS"][fk].VALID_TYPE.indexOf("prompt") > -1 && !!_this.groupDatas[gk][md][0]["FIELDS"][fk].DEFAULT_VALUE) {
                _this.groupDatas[gk][md][0]["FIELDS"][fk].promptValue = _this.groupDatas[gk][md][0]["FIELDS"][fk].DEFAULT_VALUE;
              }
            }
          }
        }
      }
    }
  },

  parseOldBiz: function parseOldBiz(groupdDatas, bdata) {
    try {
      for (var bk in bdata) {
        if (bk in groupdDatas) {
          var bd = bdata[bk];
          var md = groupdDatas[bk];
          for (var bdk in bd) {
            if (bdk in md) {
              var newModuleArr = [];
              for (var i = 0; i < bd[bdk].length; i++) {
                var mdtpl = null;
                if (md[bdk][i]) {
                  mdtpl = _.cloneDeep(md[bdk][i]);
                } else {
                  mdtpl = _.cloneDeep(md[bdk][0]);
                }
                var bdd = bd[bdk][i];
                if (!bdd) {
                  continue;
                }

                if (Object.prototype.toString.call(bdd) == "[object Array]") {
                  bdd = bdd && bdd[0] || {};
                }
                var mdd = _.cloneDeep(mdtpl);
                for (var fk in bdd) {
                  if (fk === "USESAME_INFO" && "MODULE_RADIO_BUTTON" in mdd.FIELDS) {
                    mdd["FIELDS"]["MODULE_RADIO_BUTTON"]["DEFAULT_VALUE"] = bdd["USESAME_INFO"] == "1" ? "true" : "false";
                  }

                  if (fk in mdd.FIELDS && bdd[fk] !== null) {
                    var field = mdd["FIELDS"][fk];

                    field["DEFAULT_VALUE"] = _typeof(bdd[fk]) === "object" && Object.prototype.toString.call(bdd[fk]) !== "[object Array]" ? bdd[fk]["newVal"] : bdd[fk];

                    if (field["DEFAULT_VALUE"] === null) {
                      mdd = null;
                      break;
                    }

                    if (field.VALID_TYPE.indexOf("prompt") > -1 && !!field.DEFAULT_VALUE) {
                      field.promptValue = field.DEFAULT_VALUE;
                    }
                  }
                }
                if (i > 0 && mdd) {
                  mdd.MODULE_SEQ = parseInt(mdd["MODULE_SEQ"]) + i + "";
                }

                mdd["MODULE_NUMBER"] = bdd["MODULE_NUMBER"] || i + "";

                mdd["MODULE_NUM"] = i + "";

                newModuleArr.push(mdd);
              }

              if (!_.isEmpty(newModuleArr)) {
                vm.$set(md, bdk, newModuleArr);
              }
            }
          }
        }
      }
    } catch (err) {
      consoleLog("err", err);
    }
  },
  getEmptyGroupFieldObj: function getEmptyGroupFieldObj(_this, fieldData) {
    if (_.isEmpty(fieldData)) {
      return {};
    }

    return _this.groupDatasTpl[fieldData.GROUP_ID][fieldData.MODULE_ID][0];
    var fieldObj = {
      BUSI_CODE: fieldData.BUSI_CODE,
      FIELDS: fieldData.FIELDS,
      GROUP_BUSI_PLAT: fieldData.GROUP_BUSI_PLAT,
      GROUP_ID: fieldData.GROUP_ID,
      GROUP_TIPS: fieldData.GROUP_TIPS,
      MODULE_ADD: fieldData.MODULE_ADD,
      MODULE_BUSI_PLAT: fieldData.MODULE_BUSI_PLAT,
      MODULE_CLEAN: fieldData.MODULE_CLEAN,
      MODULE_CONTROL: fieldData.MODULE_CONTROL,
      MODULE_DELETE: fieldData.MODULE_DELETE,
      MODULE_ID: fieldData.MODULE_ID,
      MODULE_NUM: fieldData.MODULE_NUM,
      MODULE_READ: fieldData.MODULE_READ,
      MODULE_SEQ: fieldData.MODULE_SEQ,
      MODULE_TITLE: fieldData.MODULE_TITLE,
      USER_TYPE: fieldData.USER_TYPE,
      MODULE_DOWNLOAD_LINK: fieldData.MODULE_DOWNLOAD_LINK || "",
      MODULE_DOWNLOAD_NAME: fieldData.MODULE_DOWNLOAD_NAME || "",
      MODULE_DOWNLOAD: fieldData.MODULE_DOWNLOAD || "",
      MODULE_IMPORT: fieldData.MODULE_IMPORT || ""
    };
    for (var fk in fieldObj.FIELDS) {
      fieldObj.FIELDS[fk]["DEFAULT_VALUE"] = "";
    }
    return fieldObj;
  },

  parseMoudleArray: function parseMoudleArray(_this, moudletpl, moudleArray) {
    if (moudleArray.length == 0) {
      return;
    }
    if (moudleArray.length > moudletpl.length) {
      var mdtpl = this.getEmptyGroupFieldObj(_this, moudletpl[0]);
      for (var i = 0; i < moudleArray.length; i++) {
        var bdd = moudleArray[i];
        var mdd = _.cloneDeep(mdtpl);
        mdd["MODULE_NUM"] = String(i);
        mdd["MODULE_NUMBER"] = String(bdd["MODULE_NUMBER"] || i);
        if (i != 0) {
          mdd.MODULE_DOWNLOAD_LINK = "";
          mdd.MODULE_DOWNLOAD = "";
          mdd.MODULE_IMPORT = "";
          mdd.MODULE_DOWNLOAD_NAME = "";
        }
        if (bdd.OPER_TYPE == 2) {
          continue;
        }
        if (i > 0) {
          mdd.MODULE_SEQ = String(parseInt(mdd["MODULE_SEQ"]) + i);
        }

        for (var fk in bdd) {
          if (fk in mdd.FIELDS && bdd[fk] !== null) {
            if (mdd["FIELDS"][fk]) {
              mdd["FIELDS"][fk]["DEFAULT_VALUE"] = bdd[fk];
            }
          }
        }

        if (i > moudletpl.length - 1) {
          if (i == moudleArray.length - 1) {
            mdd.MODULE_ADD = "1";
          } else {
            mdd.MODULE_ADD = "0";
          }

          mdd.MODULE_DELETE = "1";
          moudletpl.push(mdd);
        } else {
          if (moudleArray.length == 1) {
            mdd.MODULE_ADD = "1";
            mdd.MODULE_DELETE = "0";
          } else {

            if (moudleArray.length && i == moudleArray.length - 1) {
              mdd.MODULE_ADD = "1";
              mdd.MODULE_DELETE = "1";
            } else {
              mdd.MODULE_ADD = "0";
            }
          }
          moudletpl[i] = mdd;
        }
      }
    } else {
      for (var j = moudletpl.length - 1; j >= 0; j--) {
        var _bdd = moudleArray[j];
        if (_bdd && _bdd.OPER_TYPE == 2) {
          moudletpl.splice(j, 1);
        }
      }
      for (var _i = 0; _i < moudletpl.length; _i++) {
        moudletpl[_i]["MODULE_NUM"] = String(_i);
        var _bdd2 = moudleArray[_i] || {};
        moudletpl[_i]["MODULE_NUMBER"] = String(_bdd2["MODULE_NUMBER"] || _i);
        if (_i < moudleArray.length) {
          for (var _fk in _bdd2) {
            if (_fk in moudletpl[_i].FIELDS && _bdd2[_fk] !== null) {
              moudletpl[_i]["FIELDS"][_fk]["DEFAULT_VALUE"] = _bdd2[_fk];
            }
          }
        } else {
          for (var _fk2 in moudletpl[_i].FIELDS) {
            moudletpl[_i]["FIELDS"][_fk2]["DEFAULT_VALUE"] = moudletpl[_i].FIELDS[_fk2].DEFAULT_VALUE;
          }
        }

        if (_i > moudleArray.length - 1) {
          if (moudleArray.length && _i == moudleArray.length - 1) {
            moudletpl[_i].MODULE_ADD = "1";
          } else {
            moudletpl[_i].MODULE_ADD = "0";
          }
          moudletpl[_i].MODULE_DELETE = "1";
        } else {
          if (moudleArray.length == 1) {
            moudletpl[_i].MODULE_ADD = "1";
            moudletpl[_i].MODULE_DELETE = "0";
          } else {
            moudletpl[moudletpl.length - 1].MODULE_ADD = "1";
            if (moudletpl.length > 1 && _i > 0) {
              moudletpl[_i].MODULE_DELETE = "1";
            }
          }
        }

        if (_i > 0) {
          moudletpl[_i].MODULE_SEQ = String(parseInt(moudletpl[_i]["MODULE_SEQ"]) + 1);
        }
      }
    }
  },

  changeObjKeys: function changeObjKeys(moduleFields, targetValue) {
    _Object$keys(moduleFields).forEach(function (key) {
      targetValue[key] = moduleFields[key].DEFAULT_VALUE;
    });
  },

  getArrDiff: function getArrDiff(newData, oldArr, keyId, skipKeys, keepOldVal) {
    var that = this,
        newArr = [],
        isChange = "0",
        skipKeyArr = skipKeys && skipKeys.split(",") || [],
        skipValObj = {};
    _.each(newData, function (newObj) {
      var oldObj = {},
          matchObj = {},
          skipValObj = {},
          diff = [],
          operType = "3";
      matchObj[keyId] = newObj[keyId];

      _.each(skipKeyArr, function (skipkey) {
        skipValObj[skipkey] = newObj[skipkey];
        matchObj = _.omit(matchObj, skipkey);
        newObj = _.omit(newObj, skipkey);
      });

      oldObj = _.findWhere(oldArr, matchObj);

      if (oldArr.length == 0 && _.compact(_.values(newObj)).length == 0) {
        operType = "3";
      } else if (_.isEmpty(oldObj) && !_.isEmpty(newObj)) {
        operType = "0";
        diff = !oldObj ? that.compareInfoStandard(oldObj, newObj) : [];
      } else {
        diff = !oldObj ? [] : that.compareInfoStandard(oldObj, newObj);
        operType = diff.length ? "1" : !oldObj ? "0" : "3";

        if (keepOldVal && diff.length) {
          _.each(oldObj, function (v, k) {
            var tmpObj = _.find(diff, function (o) {
              return o.FIELD == k;
            });
            if (!tmpObj && v) {
              diff.push({
                FIELD: k,
                NEW: v,
                OLD: v
              });
            }
          });
        }
      }
      if (operType !== "3") {
        isChange = "1";
      }
      newArr.push(_Object$assign({}, {
        DIFF_INFO: diff,
        OPER_TYPE: operType
      }, newObj, skipValObj));
    });
    _.chain(oldArr).filter(function (v) {
      var matchObj = {};
      matchObj[keyId] = v[keyId];
      return !_.findWhere(newArr, matchObj);
    }).each(function (v) {
      newArr.push(_Object$assign({}, v, {
        DIFF_INFO: [v],
        OPER_TYPE: "2"
      }));
      isChange = "1";
    }).value();
    return {
      INFO: newArr,
      IS_CHANGE: isChange
    };
  },

  getTaxCountryDiffData: function getTaxCountryDiffData(infoArr, oldTaxInfo) {
    _.each(infoArr, function (tax) {
      var arrKeys = ["CITIZENSHIP", "CITIZENSHIP2", "CITIZENSHIP3", "TAXPAYER_IDNO", "TAXPAYER_IDNO2", "TAXPAYER_IDNO3", "NO_TAXPAYERID_REASON", "NO_TAXPAYERID_REASON2", "NO_TAXPAYERID_REASON3"];
      _.each(arrKeys, function (key) {
        if (tax.DIFF_INFO.length) {
          var tmpObj = _.find(tax.DIFF_INFO, function (v) {
            return v.FIELD == key;
          }) || "";
          if (!_.isEmpty(tmpObj)) {
            tax.DIFF_INFO.push({
              FIELD: key,
              NEW: oldTaxInfo[key],
              OLD: oldTaxInfo[key]
            });
          }
        }
      });
    });
    return infoArr;
  },

  getTaxAssetDiffData: function getTaxAssetDiffData(infoArr, oldTaxInfo) {
    _.each(infoArr, function (tax) {
      var arrKeys = ["PAYMENT_TYPE1", "PAYMENT_TYPE2", "PAYMENT_TYPE3", "PAYMENT_TYPE4", "PAYMENT_CURR1", "PAYMENT_CURR2", "PAYMENT_CURR3", "PAYMENT_CURR4", "PAYMENT_ASSET1", "PAYMENT_ASSET2", "PAYMENT_ASSET3", "PAYMENT_ASSET4"];
      _.each(arrKeys, function (key) {
        if (tax.DIFF_INFO.length) {
          var tmpObj = _.find(tax.DIFF_INFO, function (v) {
            return v.FIELD == key;
          }) || "";
          if (!_.isEmpty(tmpObj)) {
            tax.DIFF_INFO.push({
              FIELD: key,
              NEW: oldTaxInfo[key],
              OLD: oldTaxInfo[key]
            });
          }
        }
      });
    });
    return infoArr;
  },

  compareInfoStandard: function compareInfoStandard(objOld, objNew, skipKeys) {
    var diff = [],
        newObj = objNew;

    skipKeys && _.each(skipKeys.split(","), function (skipkey) {
      newObj = _.omit(newObj, skipkey);
    });
    _.each(newObj, function (v, k) {
      if (!objOld || null !== (objOld[k] || "") && v !== (objOld[k] || "")) {
        diff.push({
          FIELD: k,
          OLD: objOld && objOld[k] || "",
          NEW: v || ""
        });
      }
    });
    return diff;
  },

  compareInfo: function compareInfo(oldVal, newVal) {
    var arr = [];
    _Object$keys(newVal).forEach(function (key) {
      if (newVal[key] !== oldVal[key] && oldVal && !(oldVal[key] == undefined && stringConfig.isEmptyStr(newVal[key]))) {
          arr.push({
            FIELD: key,
            OLD: oldVal[key],
            NEW: newVal[key]
          });
        }
    });
    return arr;
  },

  compareJsonDiff: function compareJsonDiff(objOld, objNew, mainKey) {
    var diff = [];

    if (objNew && mainKey && !objNew[mainKey]) {
      return diff;
    }
    _.each(objNew, function (v, k) {
      if (_Object$keys(objOld).includes(k)) {
        if (!objOld || null !== (_.trim(objOld[k]) || "") && v !== (_.trim(objOld[k]) || "")) {
          diff.push({
            FIELD: k,
            OLD: objOld && objOld[k] || "",
            NEW: v || ""
          });
        }
      }
    });
    return diff;
  },

  compareInfo2: function compareInfo2(objOld, objNew, mainKey) {
    var diff = [];

    if (objNew && mainKey && !objNew[mainKey]) {
      return diff;
    }
    _.each(objNew, function (v, k) {
      if (!objOld || null !== (_.trim(objOld[k]) || "") && v !== (_.trim(objOld[k]) || "")) {
        diff.push({
          FIELD: k,
          OLD: objOld && objOld[k] || "",
          NEW: v || ""
        });
      }
    });
    return diff;
  },

  isSubjectIdentity: function isSubjectIdentity(custIdent, checkIdent) {
    if (_.isUndefined(custIdent) || _.isUndefined(checkIdent)) {
      consoleLog("主体身份没有传入！");
    }
    if (!_.isString(custIdent) || !_.isString(checkIdent)) {
      return false;
    }
    var checkIdents = checkIdent.split(","),
        custIdents = custIdent.split(""),
        flag = false;
    _.each(checkIdents, function (v) {
      if (_.indexOf(custIdents, dict[v]) != -1) {
        flag = true;
        return false;
      }
    });
    return flag;
  },

  getMoudleArrDiff: function getMoudleArrDiff(fieldData, oldArr, mainKey, otherKey) {
    var saveArr = [];
    if (oldArr.length == 0) {
      _.each(fieldData, function (curFieldItem) {
        if (stringConfig.isNotEmptyStr(curFieldItem.FIELDS[mainKey].DEFAULT_VALUE)) {

          var saveItemObj = {};
          saveItemObj[mainKey] = curFieldItem.FIELDS[mainKey].DEFAULT_VALUE;
          saveItemObj[otherKey] = curFieldItem.FIELDS[otherKey].DEFAULT_VALUE;
          saveItemObj["OPER_TYPE"] = 1;
          saveItemObj["DIFF_INFO"] = [{
            "FIELD": mainKey,
            "OLD": "",
            "NEW": curFieldItem.FIELDS[mainKey].DEFAULT_VALUE
          }, {
            "FIELD": otherKey,
            "OLD": "",
            "NEW": curFieldItem.FIELDS[otherKey].DEFAULT_VALUE
          }];
          saveArr.push(saveItemObj);
        }
      });
    } else {
      var newArr = [];
      _.each(fieldData, function (curFieldItem) {
        var saveItemObj = {};
        saveItemObj[mainKey] = curFieldItem.FIELDS[mainKey].DEFAULT_VALUE;
        saveItemObj[otherKey] = curFieldItem.FIELDS[otherKey].DEFAULT_VALUE;
        saveItemObj["OPER_TYPE"] = "3";
        saveItemObj["DIFF_INFO"] = [];
        newArr.push(saveItemObj);
      });

      var addModArr = _.differenceWith(newArr, oldArr, function (a, b) {
        return a[mainKey] === b[mainKey] && a[otherKey] === b[otherKey];
      });

      var delModArr = _.differenceWith(oldArr, newArr, function (a, b) {
        return a[mainKey] === b[mainKey] && a[otherKey] === b[otherKey];
      });

      var modModArr = [];
      _.intersectionWith(oldArr, newArr, function (a, b) {
        if (a[mainKey] === b[mainKey]) {
          if (b[otherKey] != a[otherKey] && _typeof(b[otherKey]) != "object" || !_.isEqual(b[otherKey], a[otherKey])) {
            var tempObj = {};
            tempObj[mainKey] = b[mainKey];
            tempObj[otherKey] = b[otherKey];
            tempObj.OPER_TYPE = "1";
            tempObj.DIFF_INFO = [{
              "FIELD": otherKey,
              "old": a[otherKey],
              "new": b[otherKey]
            }];
            modModArr.push(tempObj);
          }
        } else {
          if (b[otherKey] != a[otherKey] && _typeof(b[otherKey]) != "object" || !_.isEqual(b[otherKey], a[otherKey])) {
            var _tempObj = {};
            _tempObj[mainKey] = b[mainKey];
            _tempObj[otherKey] = b[otherKey];
            _tempObj.OPER_TYPE = "0";
            _tempObj.DIFF_INFO = [{
              "FIELD": mainKey,
              "old": a[mainKey],
              "new": b[mainKey]
            }, {
              "FIELD": mainKey,
              "old": a[mainKey],
              "new": b[otherKey]
            }];
            modModArr.push(_tempObj);
          } else {
            var _tempObj2 = {};
            _tempObj2[mainKey] = b[mainKey];
            _tempObj2[otherKey] = b[otherKey];
            _tempObj2.OPER_TYPE = "1";
            _tempObj2.DIFF_INFO = [{
              "FIELD": mainKey,
              "old": a[mainKey],
              "new": b[mainKey]
            }];
            modModArr.push(_tempObj2);
          }
        }
      });

      if (addModArr.length) {
        consoleLog("新增的数组===", addModArr);
        _.each(addModArr, function (addItem) {
          var upDataBool = false;
          _.each(saveArr, function (saveItem) {
            if (addItem[mainKey] == saveItem[mainKey]) {
              upDataBool = true;
              return false;
            }
          });
          if (!upDataBool) {
            var defObj = {};
            defObj[mainKey] = addItem[mainKey];
            defObj[otherKey] = addItem[otherKey];
            defObj["OPER_TYPE"] = "1";
            defObj["DIFF_INFO"] = [{
              "FIELD": mainKey,
              "OLD": "",
              "NEW": addItem[mainKey]
            }, {
              "FIELD": otherKey,
              "OLD": "",
              "NEW": addItem[otherKey]
            }];
            saveArr.push(defObj);
          }
        });
      }
      consoleLog("删除的数组===", saveArr);
      if (delModArr.length) {
        _.each(delModArr, function (addItem) {
          var upDataBool = false;
          _.each(saveArr, function (saveItem) {
            if (addItem[mainKey] == saveItem[mainKey] && addItem[otherKey] == saveItem[otherKey]) {
              upDataBool = true;
              return false;
            }
          });
          if (!upDataBool) {

            var defObj = {};
            defObj[mainKey] = addItem[mainKey];
            defObj[otherKey] = addItem[otherKey];
            defObj["OPER_TYPE"] = "2";
            defObj["DIFF_INFO"] = [];
            saveArr.push(defObj);
          }
        });
      }
      consoleLog("删除的数组===", saveArr);
      if (modModArr.length) {
        _.each(modModArr, function (addItem) {
          var upDataBool = false;
          _.each(saveArr, function (saveItem) {
            if (addItem[mainKey] == saveItem[mainKey] && addItem[otherKey] == saveItem[otherKey]) {
              upDataBool = true;
              return false;
            }
          });
          if (!upDataBool) {
            saveArr.push(addItem);
          }
        });
      }

      _.each(newArr, function (newItem) {
        var upDataBool = false;
        _.each(saveArr, function (saveItem) {
          if (newItem[mainKey] == saveItem[mainKey] && newItem[otherKey] == saveItem[otherKey]) {
            upDataBool = true;
            return false;
          }
        });
        if (!upDataBool) {
          saveArr.push(newItem);
        }
      });
    }
    return saveArr;
  },

  getMoudleArrIsChangeBool: function getMoudleArrIsChangeBool(_this, moudleArray) {
    var isChangeBool = false;
    _.forEach(moudleArray, function (item) {
      if (item.DIFF_INFO.length) {
        isChangeBool = true;
        return;
      }
    });
    return isChangeBool;
  },

  checkInfoRuler: function checkInfoRuler(response) {
    var showMsg = "";
    if (response.AGE_OCCU_CHECK) {
      if (response.AGE_OCCU_CHECK.CHECK_CODE && response.AGE_OCCU_CHECK.CHECK_CODE != "1") {
        showMsg = showMsg + response.AGE_OCCU_CHECK.CHECK_RES || "" + "/n";
      }
    }
    if (response.OCCU_POSI_CHECK) {
      if (response.OCCU_POSI_CHECK.CHECK_CODE && response.OCCU_POSI_CHECK.CHECK_CODE != "1") {
        showMsg = showMsg + response.OCCU_POSI_CHECK.CHECK_RES || "" + "/n";
      }
    }

    if (response.OCCU_EDU_CHECK) {
      if (response.OCCU_EDU_CHECK.CHECK_CODE && response.OCCU_EDU_CHECK.CHECK_CODE != "1") {
        showMsg = showMsg + response.OCCU_EDU_CHECK.CHECK_RES || "" + "/n";
      }
    }

    if (response.CREDIT_CHECK) {
      if (response.CREDIT_CHECK.CHECK_CODE && response.CREDIT_CHECK.CHECK_CODE != "1") {
        showMsg = showMsg + response.AGE_OCCU_CHECK.CHECK_RES || "" + "/n";
      }
    }

    if (response.AGE_EDU_CHECK) {
      if (response.AGE_EDU_CHECK.CHECK_CODE && response.AGE_EDU_CHECK.CHECK_CODE != "1") {
        showMsg = showMsg + response.AGE_OCCU_CHECK.CHECK_RES || "" + "/n";
      }
    }
    return showMsg;
  },

  check_Bank_Module_Radio_flag: function check_Bank_Module_Radio_flag(_this) {
    if (_this.userType == "0") {
      return _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDTYPE.DEFAULT_VALUE == _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_TYPE.DEFAULT_VALUE && _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.FULLNAME.DEFAULT_VALUE == _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.USER_FNAME.DEFAULT_VALUE;
    } else {
      return _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDTYPE.DEFAULT_VALUE == _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_TYPE.DEFAULT_VALUE && _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.IDNO.DEFAULT_VALUE == _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.ID_CODE.DEFAULT_VALUE && _this.groupDatas.CUST_INFO_PAGE2.CUST_BANK_INFO[0].FIELDS.FULLNAME.DEFAULT_VALUE == _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS.USER_FNAME.DEFAULT_VALUE;
    }
  },

  isSyncBankFlag: function isSyncBankFlag(_this, bankAcctInfoForm, newBaseForm) {
    var tempBool = "0";
    _.forEach(bankAcctInfoForm, function (item) {
      if (item.FULLNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || item.IDNO != newBaseForm.ID_CODE.DEFAULT_VALUE || item.IDTYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE) {
        tempBool = "1";
        return false;
      }
    });

    return tempBool;
  },

  checkImportantInfoChange: function checkImportantInfoChange(oldBaseForm, newBaseForm) {
    return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE;
  },
  getOldBankAcct: function getOldBankAcct(_this) {
    var oldBankInfo = _this.oppBusiData.bankAcctInfo;
    _.forEach(oldBankInfo, function (oldItem) {
      oldItem.FULLNAME = oldItem.BSB_USER_FNAME;
      _.forEach(_this.oppBusiData.bankData, function (sysItem) {
        if (oldItem.BANKCODE == sysItem.EXT_ORG) {
          oldItem.ORG_NAME = sysItem.ORG_NAME;
          return false;
        }
      });
    });

    return oldBankInfo;
  },

  checkBaseInfoChange: function checkBaseInfoChange(_this) {
    var oldBaseForm = _this.oppBusiData.custBaseInfo,
        newBaseForm = _this.groupDatas.CUST_INFO_PAGE1.CUST_BASIC_INFO_STEP1[0].FIELDS;

    return oldBaseForm.USER_FNAME != newBaseForm.USER_FNAME.DEFAULT_VALUE || oldBaseForm.ID_TYPE != newBaseForm.ID_TYPE.DEFAULT_VALUE || oldBaseForm.ID_CODE != newBaseForm.ID_CODE.DEFAULT_VALUE || oldBaseForm.USER_NAME != newBaseForm.USER_NAME.DEFAULT_VALUE;
  },
  getSignBankRequestData: function getSignBankRequestData(_this) {
    var customerInfo = this.getCustomerAllData(_this);
    var basedata = {
      "CUST_CODE": customerInfo != null ? customerInfo.CUST_CODE : "",
      "CUACCT_CODE": customerInfo != null ? customerInfo.CUACCT_CODE : "",
      "INT_ORG": customerInfo != null ? customerInfo.INT_ORG : "",
      "RECORD": "1"
    };
    return basedata;
  },

  getOrgIdCode: function getOrgIdCode(idCode) {
    if (!idCode || idCode.length !== 18) {
      return idCode;
    }
    var tmpCode = idCode.substring(8, 17);
    return tmpCode.substring(0, 8) + "-" + tmpCode.substring(8, 9);
  },

  getVerificationCode: function getVerificationCode(_this, params, field, codefield) {
    var _this3 = this;

    if (params.MOBILE) {
      var obj = {
        ORG_CODE: params.ORG_CODE,
        MOBILE: params.MOBILE,
        EXP_SECS: params.EXP_SECS || 300 };
      _this.loading = true;
      _this.loadingText = "正在获取验证码";
      smsService.getSmsValidCode(obj).then(function (data) {
        if (data && data.SEND_FLAG == "1") {
          var remainTime = parseInt(_this.oppBusiData.busiCommonParams.MOBILE_VALID_TIME) || 120;
          _this.$set(field, "remainTime", remainTime);
          codefield.DEFAULT_VALUE = "";
          _this3.showMsgBox(_this, "验证码已发送到：【" + params.MOBILE + "】，请注意查收！");

          _this.$set(field, "codeStatus", "codeStart");
          _this.oppBusiData.isAssignValidCodeTimeout = true;
          setTimeout(function () {
            _this.oppBusiData.isAssignValidCodeTimeout = false;
            _this.$set(field, "codeStatus", "codeEnd");
          }, remainTime * 1000);
          _this.oppBusiData.ASSIGN_AUTH_ID = data.AUTH_ID;
        } else {
          _this3.showMsgBox(_this, "获取验证码失败");
        }
      }).finally(function () {
        _this.loading = false;
        _this.loadingText = "";
      });
    } else {
      this.showMsgBox(_this, "请输入正确的手机号");
    }
  },

  parseFieldsToObj: function parseFieldsToObj(moudle, filedName, filterArr, correct) {
    correct = correct || "";
    filterArr = filterArr || [];
    var retrunObj = {};

    var files = moudle.length && moudle[0].FIELDS || moudle.FIELDS;
    for (var field in files) {
      if (filterArr && filterArr.length > 0 && _.indexOf(filterArr, field) != -1) {
        continue;
      }
      _Object$assign(retrunObj, _defineProperty({}, field, files[field][filedName]), correct ? _defineProperty({}, "correct_" + field, files[field].correct) : {});
    }

    return retrunObj;
  },

  parseFieldsToObjAndAddPoliceResult: function parseFieldsToObjAndAddPoliceResult(moudle, filedName, filterArr, correct) {
    correct = correct || "";
    filterArr = filterArr || [];
    var retrunObj = {};
    var files = moudle.length && moudle[0].FIELDS || moudle.FIELDS;
    for (var field in files) {
      if (filterArr && filterArr.length > 0 && _.indexOf(filterArr, field) != -1) {
        continue;
      }
      _Object$assign(retrunObj, _defineProperty({}, field, files[field][filedName]), correct ? _defineProperty({}, "correct_" + field, files[field].correct) : {});
    }

    if (moudle.POLICE_FLAG == "1") {
      _Object$assign(retrunObj, {
        POLICE_FLAG: moudle.POLICE_FLAG,
        POLICE_CHECK_SNO: moudle.POLICE_CHECK_SNO,
        POLICE_VALID_RESULT: moudle.POLICE_VALID_RESULT,
        IS_POLICE_SUCCESS_FLAG: "1"
      });
    }
    return retrunObj;
  },

  parsefieldsDefaultValueToNull: function parsefieldsDefaultValueToNull(module, filterArr) {
    filterArr = filterArr || [];
    module = _.isArray(module) ? module[0] : module;
    for (var field in module.FIELDS) {
      if (_.indexOf(filterArr, field) == -1) {
        module.FIELDS[field].DEFAULT_VALUE = "";
      }
    }
  },
  changefieldsRequire: function changefieldsRequire(module, required, filterArr) {
    filterArr = filterArr || [];
    module = _.isArray(module) ? module[0] : module;
    for (var field in module.FIELDS) {
      if (_.indexOf(filterArr, field) == -1) {
        module.FIELDS[field].FIELD_REQUIRED = required;
      }
    }
  },
  hideFieldInModule: function hideFieldInModule(module, hideFlag, fieldId) {
    fieldId = _.isArray(fieldId) ? fieldId : [fieldId ? fieldId : ""];
    var moduleObj = _.isArray(module) ? module[0] : module;

    for (var field in moduleObj.FIELDS) {
      if (fieldId.includes(field)) {
        consoleLog("cccc");
      } else {
        moduleObj.FIELDS[field].FIELD_CONTROL = hideFlag;
      }
    }
  },
  isSyncCSDC: function isSyncCSDC(obj) {
    var changeBaseInfo = obj.changeBaseInfo;
    var isChange = function isChange(paramArr) {
      var tempFlag = void 0;
      for (var i = 0; i < changeBaseInfo.length; i++) {
        tempFlag = !!_.find(changeBaseInfo[i].value, function (value1) {
          return _.indexOf(paramArr, value1.key) != -1 ? true : false;
        });
        if (!!tempFlag) {
          break;
        }
      }
      return !!tempFlag;
    };
    if (changeBaseInfo.length > 0) {
      var param = ["MOBILE_TEL", "FAX", "EMAIL", "CITIZENSHIP", "NATIONALITY", "EDUCATION", "SEX", "BIRTHDAY", "CAPITAL_ATTR", "NATIONAL_ATTR", "OCCU_TYPE", "LEGAL_REP", "LEGAL_REP_ID_TYPE", "LEGAL_REP_ID_CODE", "SZORGTYPE", "SMFUND_MANAGER_ID", "ID_EXP_DATE", "ID_ADDR", "ORG_ID_CODE", "ORG_ID_EXP_DATE", "ID_ADDR2", "FZ_ID_TYPE", "FZ_ID_CODE", "FZ_ID_EXP_DATE"];
      if (isChange(param)) {
        return true;
      }

      var temp_LINKTEL_ORDER = obj.showInitData.LINKTEL_ORDER === obj.showChangeData.LINKTEL_ORDER,
          temp_LINKADDR_ORDER = obj.showInitData.LINKADDR_ORDER === obj.showChangeData.LINKADDR_ORDER;

      if (!obj.showInitData.LINKTEL_ORDER || temp_LINKTEL_ORDER) {
        var linkTel = [];
        "1" === obj.showChangeData.LINKTEL_ORDER || "2" === obj.showChangeData.LINKTEL_ORDER ? linkTel.push("TEL") : "3" === obj.showChangeData.LINKTEL_ORDER ? linkTel.push("OFFICE_TEL") : "4" === obj.showChangeData.LINKTEL_ORDER ? linkTel.push("WELL_TEL") : undefined;
        if (linkTel.length > 0 && isChange(linkTel)) {
          return true;
        }
      } else {
        var initLinkTel = "1" === obj.showInitData.LINKTEL_ORDER || "2" === obj.showInitData.LINKTEL_ORDER ? obj.showInitData.TEL : "3" === obj.showInitData.LINKTEL_ORDER ? obj.showInitData.OFFICE_TEL : "4" === obj.showInitData.LINKTEL_ORDER ? obj.showInitData.WELL_TEL : "",
            resultLinkTel = "1" === obj.showChangeData.LINKTEL_ORDER || "2" === obj.showChangeData.LINKTEL_ORDER ? obj.showChangeData.TEL : "3" === obj.showChangeData.LINKTEL_ORDER ? obj.showChangeData.OFFICE_TEL : "4" === obj.showChangeData.LINKTEL_ORDER ? obj.showChangeData.WELL_TEL : "";

        if (initLinkTel !== resultLinkTel) {
          return true;
        }
      }

      if (temp_LINKADDR_ORDER && isChange(obj.showChangeData.LINKADDR_ORDER === "1" ? ["ADDRESS", "ZIP_CODE"] : ["CORP_ADDR", "ID_ZIP_CODE"])) {
        return true;
      }
      var initLinkAddr = obj.showInitData.LINKADDR_ORDER === "1" ? obj.showInitData.ADDRESS : obj.showInitData.CORP_ADDR,
          resultLinkAddr = obj.showChangeData.LINKADDR_ORDER === "1" ? obj.showChangeData.ADDRESS : obj.showChangeData.CORP_ADDR,
          initZipCode = obj.showInitData.LINKADDR_ORDER === "1" ? obj.showInitData.ZIP_CODE : obj.showInitData.ID_ZIP_CODE,
          resultZipCode = obj.showChangeData.LINKADDR_ORDER === "1" ? obj.showChangeData.ZIP_CODE : obj.showChangeData.ID_ZIP_CODE;

      if (initLinkAddr !== resultLinkAddr || initZipCode !== resultZipCode) {
        return true;
      }
    }
  },

  parseMoudleArrayRestore: function parseMoudleArrayRestore(_this, moudletpl, moudleArray) {
    if (moudletpl.length > moudleArray.length) {
      moudletpl.splice(moudleArray.length, moudletpl.length);
      moudletpl[moudletpl.length - 1]["MODULE_ADD"] = "1";
    }

    this.parseMoudleArray(_this, moudletpl, moudleArray);

    for (var i = 0; i < moudletpl.length; i++) {
      for (var field in moudletpl[i].FIELDS) {
        moudletpl[i].FIELDS[field].correct = moudleArray[i]["correct_" + field];
        if (typeof moudleArray[i]["correct_" + field] == "string" && moudleArray[i]["correct_" + field] == "true" || typeof moudleArray[i]["correct_" + field] == "boolean" && moudleArray[i]["correct_" + field]) {
          moudletpl[i].FIELDS[field].message = "";
        }
      }
    }
  },

  setZipCode: function setZipCode(_this, address) {
    return new _Promise(function (resolve, reject) {
      if (_.isArray(address) && address.length == 3) {
        var _address = _slicedToArray(address, 3),
            provice = _address[0],
            city = _address[1],
            district = _address[2];

        if (provice === "不详" || city === "不详" && district === "不详") {
          resolve("");
        }
        return _this.$syscfg.K_Request("F0000000", {
          SERVICE_CODE: "QS200085",
          PROVINCE_NAME: provice,
          CITY_NAME: city == "不详" ? "" : city,
          DISTRICT_NAME: district == "不详" ? "" : district
        }).then(function (zipData) {
          if (zipData.Code == "0" && zipData.Data.length > 0) {
            var zipCode = zipData.Data[0] && zipData.Data[0].ZIP_CODE;
            resolve(zipCode || "");
          } else {
            resolve("");
          }
        });
      } else {
        consoleLog("填充邮政编码出错，数据格式不满足");
        resolve("");
      }
    });
  },

  getGroupTypeCode: function getGroupTypeCode(idCode) {
    if (!_.isString(idCode)) {
      return "";
    }
    var groupIdCode = "";

    if (18 === idCode.length) {
      groupIdCode = idCode.substring(8, 16) + "-" + idCode.charAt(idCode.length - 2);
    }

    if (24 === idCode.length) {
      groupIdCode = idCode.substring(15, 23) + "-" + idCode.charAt(idCode.length - 1);
    }
    return groupIdCode;
  },

  getChangeCSDCData: function getChangeCSDCData(param) {
    var showData = [],
        cofParamObj = [{
      "0": {
        ID_EXP_DATE: "证件有效期",
        MOBILE_TEL: "手机号码",
        ADDRESS: "联系地址",
        OCCU_TYPE: "职业",
        SEX: "性别"
      },
      "1": {
        ID_TYPE2: "辅助证件类型",
        ID_CODE2: "证件号码",
        ID_EXP_DATE2: "证件有效期",
        MOBILE_TEL: "联系电话",
        ADDRESS: "联系地址",
        ID_ADDR: "证件地址",
        LEGAL_REP: "法定代表人姓名",
        LEGAL_REP_ID_CODE: "法定代表人证件号码",
        LEGAL_REP_ID_TYPE: "法定代表人证件类型",
        NATIONAL_ATTR: "国有属性"
      }
    }],
        paramObj = cofParamObj[0][param.USER_TYPE],
        csdcCustInfo = param.csdcCustInfo,
        sysCustInfo = param.sysCustInfo;
    return _Promise.all([dict.transformDict(csdcCustInfo, ["SEX", "ID_TYPE", "NATIONAL_ATTR", {
      "OCCU_TYPE": "OCCU_EXTYPE_NEW",
      "LEGAL_REP_ID_TYPE": "ID_TYPE"
    }]), dict.transformDict(sysCustInfo, ["SEX", "ID_TYPE", "NATIONAL_ATTR", {
      "OCCU_TYPE": "OCCU_EXTYPE_NEW",
      "LEGAL_REP_ID_TYPE": "ID_TYPE"
    }])]).then(function (res) {
      var dictCSDCData = res[0],
          dictSysData = res[1];
      _.each(paramObj, function (tempParam, key1) {
        if (_.trim(sysCustInfo[key1]) !== _.trim(csdcCustInfo[key1]) && !(sysCustInfo[key1] === "" && (csdcCustInfo[key1] === "-1" || csdcCustInfo[key1] === " " || csdcCustInfo[key1] === void 0))) {
          var changeValue = {};

          if (key1 === "ID_CODE2") {
            changeValue["NEW_ID_CODE2"] = dictSysData[key1];
          } else {
            changeValue[key1] = dictSysData[key1];
          }
          showData.push({
            key: key1,
            name: tempParam,
            value: {
              change: dictSysData[key1 + "_TEXT"] || dictSysData[key1],
              init: dictCSDCData[key1 + "_TEXT"] || (dictCSDCData[key1] === "-1" ? "" : dictCSDCData[key1]) || ""
            },
            changeValue: changeValue
          });
        }
      });
      return showData;
    });
  },
  otherTelCheck: function otherTelCheck(_this, fieldData, mobileTel) {
    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
        that = this;
    _this.myLoading({
      loadingText: "正在进行手机号码核查",
      autoHide: false
    });
    custService.otherTelMobileCheck(_Object$assign(customerInfo, {
      MOBILE_TEL: mobileTel,
      ACCTBIZ_CLS: "02"
    })).then(function (data) {
      consoleLog("手机核查结果", data);
      if (data.Code == 0) {
        _this.myLoading({
          showLoading: false
        });

        _this.oppBusiData.TEL_CHECK_FLAG = true;
        _this.oppBusiData.checkedTel = mobileTel;
        _this.oppBusiData.NEED_BILL_LIST = "0";
      } else {
        custService.otherTelMobileCheck(_Object$assign(customerInfo, {
          MOBILE_TEL: mobileTel,
          ACCTBIZ_CLS: "03"
        })).then(function (data) {
          if (data.Code == 0) {
            _this.oppBusiData.checkedTel = mobileTel;
            _this.oppBusiData.TEL_CHECK_FLAG = true;
            _this.oppBusiData.NEED_BILL_LIST = "0";
          } else {
            _this.oppBusiData.TEL_CHECK_FLAG = false;
            _this.alert({
              messageText: "因您的手机号码核查不通过，需要您提供话费清单证明，请知悉！",
              cancelButtonText: "返回修改",
              confirmButtonText: "我已知晓",
              confirmedAction: function confirmedAction() {
                _this.oppBusiData.checkedTel = mobileTel;
                _this.oppBusiData.NEED_BILL_LIST = "1";
              },
              canceledAction: function canceledAction() {
                fieldData.SELF_OR_OTHER.FIELD_CONTROL = "1";
                fieldData.OTHER_CUST_FNAME_OWNER.FIELD_CONTROL = "1";
                fieldData.OTHER_ID_TYPE_OWNER.FIELD_CONTROL = "1";
                fieldData.OTHER_ID_CODE_OWNER.FIELD_CONTROL = "1";
                fieldData.OTHER_CONTROLER_RELATION.FIELD_CONTROL = "1";
                fieldData.SELF_OR_OTHER.DEFAULT_VALUE = "";
                fieldData.OTHER_CUST_FNAME_OWNER.DEFAULT_VALUE = "";
                fieldData.OTHER_ID_TYPE_OWNER.DEFAULT_VALUE = "";
                fieldData.OTHER_ID_CODE_OWNER.DEFAULT_VALUE = "";
                fieldData.OTHER_CONTROLER_RELATION.DEFAULT_VALUE = "";
                fieldData.MOBILE_TEL.DEFAULT_VALUE = "";
                fieldData.MOBILE_TEL.BUTTON_ENABLE = false;
                clearInterval(_this.oppBusiData.interTimer);
                _this.$set(fieldData.MOBILE_TEL, "FIELD_BUTTON_TXT", "发送验证码");
                _this.groupDatas.CUST_LINK_INFO.CUST_LINK_INFO[0].FIELDS.VALIDATE_CODE.FIELD_CONTROL = "0";
                _this.oppBusiData.IDENTIFY_CODE_CHECK_FLAG = false;
              }
            });
          }
        }).finally(function () {
          _this.myLoading({
            showLoading: false
          });
        });
      }
    }).catch(function (err) {
      consoleLog(err);
      _this.alert({
        messageText: "手机号码核查失败，请重新核查或跳过核查并提供您的话费清单！",
        cancelButtonText: "提供话费清单",
        confirmButtonText: "重新查询",
        confirmedAction: function confirmedAction() {
          _this.oppBusiData.checkedTel = mobileTel;
          that.otherTelCheck(_this, fieldData, mobileTel);
        },
        canceledAction: function canceledAction() {
          _this.oppBusiData.checkedTel = mobileTel;
          _this.oppBusiData.NEED_BILL_LIST = "1";
        }
      });
    });
  },
  multiTelUseCheck: function multiTelUseCheck(_this, field, type) {
    if (oppService.getBusiCommonParamsFromCacheObjs("IS_OTHER_FIXED_PHONE_CHECK") === "0") {
      return;
    }

    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
    custService.isMutiplTel(field.DEFAULT_VALUE, type, customerInfo).then(function (data) {
      if (data && data.length >= 2) {
        field.correct = false;
        field.message = "该固定电话号码已被多人使用，请重新输入";
      }
    });
  },

  dealAllMenu: function dealAllMenu(menuList, noAddMenuName) {},

  commonClean: function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var vm;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              vm = window.vm;

              vm.$store.commit(vm.$types.UPDATE_BIZ_ROUTE_INDEX, 0);
              vm.$store.commit(vm.$types.UPDATE_PRE_BIZ_ROUTE_INDEX, null);
              vm.$store.commit(vm.$types.UPDATE_BIZ_ROUTE_TABLE, {});
              vm.$store.commit(vm.$types.UPDATE_IMAGE_COLLECT_OBJ, null);
              vm.$store.commit(vm.$types.UPDATE_OPEN_ACCTTYPE, "");
              vm.$store.commit(vm.$types.UPDATE_APPT_SN, "");
              vm.$store.commit(vm.$types.UPDATE_B_SNO, "");
              vm.$store.commit(vm.$types.UPDATE_OLD_BIZ_DATA, null);
              vm.$store.commit(vm.$types.UPDATE_BUSI_CODE, "");
              vm.$storage.removeSession(vm.$definecfg.BUSI_DEF_INFO, null);
              vm.$storage.removeSession(vm.$definecfg.OPP_BUSI_DATA);

              vm.$storage.removeSession(vm.$definecfg.BUSI_INFO);
              vm.$storage.removeSession(vm.$definecfg.BUSI_NAME);
              vm.$storage.removeSession(vm.$definecfg.BUSI_SCOPE);
              vm.$storage.removeSession(vm.$definecfg.F_CUST_ORG_CODE);
              vm.$storage.removeSession(vm.$definecfg.FUND_LIST);
              vm.$storage.removeSession(vm.$definecfg.IS_OPENAGAIN_CHECK_FLAG);
              vm.$storage.removeSession(vm.$definecfg.MATCH_BIZ_TYPE);
              vm.$storage.removeSession(vm.$definecfg.NEED_SHOW_EVALUAT_BEFORE_INPAGE);
              vm.$storage.removeSession(vm.$definecfg.ONLY_DUAL_RECORD_ROUTE_INDEX);
              vm.$storage.removeSession(vm.$definecfg.OPEN_FUND_ACCT);
              vm.$storage.removeSession(vm.$definecfg.OTC_ORG_LIST);
              vm.$storage.removeSession(vm.$definecfg.VTM_VOICE_INPUT);
              vm.$storage.removeSession(vm.$definecfg.CSDC_REJECT_FLAG);
              vm.$storage.removeSession(vm.$definecfg.GPQQ_CSDC_TIME_FLAG);
              vm.$storage.removeSession(vm.$definecfg.PRO_B_SNO);
              vm.$storage.removeLocal(vm.$definecfg.BUSI_COMM_PARAM);
              vm.$storage.removeLocal(vm.$definecfg.BUSI_COMM_PARAM_OBJS);
              vm.$storage.removeLocal(vm.$definecfg.LOGIN_USER_INFO);
              vm.$storage.removeLocal(vm.$definecfg.MATCH_OBJ);
              vm.$storage.removeLocal(vm.$definecfg.OLD_NAV_ROUTE);
              vm.$storage.removeLocal(vm.$definecfg.OLD_BIZ_ROUTE);
              vm.$storage.removeLocal(vm.$definecfg.PRE_MODULE_DATA_CACHE);
              vm.$storage.removeLocal(vm.$definecfg.PRE_GROUP_DATA_CACHE);
              vm.$storage.removeLocal(vm.$definecfg.VTM_USER_INFO);
              vm.$storage.removeLocal(vm.$definecfg.GPQQ_INIT_DATA);
              vm.$store.commit(vm.$types.UPDATE_REJECT_REMARK, "");
              vm.$store.commit(vm.$types.UPDATE_ROUTE_TABLE_FLAG, false);
              vm.$store.commit(vm.$types.UPDATE_IMG_NAV_ROUTE_TABLE, "");
              vm.$store.commit(vm.$types.UPDATE_REJECT_TOGGLED, true);
              vm.$store.commit(vm.$types.UPDATA_IMAGE_NAV_SUBMIT_NEED, false);
              vm.$store.commit(vm.$types.UPDATA_IMAGE_NAV_SUBMIT_SUCCESS, false);
              vm.$store.commit(vm.$types.UPDATE_TRANS_BIZ_DATA, null);

            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function commonClean() {
      return _ref5.apply(this, arguments);
    }

    return commonClean;
  }(),

  homeClean: function homeClean() {
    this.commonClean();
    var vm = window.vm;

    vm.$store.commit(vm.$types.UPDATE_IS_LOGIN, false);
    vm.$store.commit(vm.$types.UPDATE_HAS_PASSWORD, false);
    vm.$store.commit(vm.$types.UPDATE_IS_EXTERAL, false);
    vm.$store.commit(vm.$types.UPDATE_USER_TYPE, "");
    vm.$store.commit(vm.$types.UPDATE_CUSTOMER_INFO, "");
    vm.$storage.removeLocal(vm.$definecfg.ALL_MENU);
    vm.$storage.removeLocal(vm.$definecfg.CUST_ALL_INFO);
  },

  homeCustomerClean: function homeCustomerClean() {
    this.commonClean();
    var vm = window.vm;
  },
  getCsdcRejectFlag: function getCsdcRejectFlag(_this, START_OPEN_TIME) {
    var isCsdcTimeReject = function isCsdcTimeReject() {
      var that = _this;
      return csdcService.queryCSDCTime().then(function (csdcTime) {
        if (csdcTime == "true") {
          return false;
        }
        var openDate = date.formatDate(START_OPEN_TIME, "yyyyMMdd");
        var nowDate = date.getClientDate();
        var days = date.getDifferDays(openDate, nowDate);
        if (days >= 1) {
          return false;
        } else {
          return true;
        }
      });
    };
    return isCsdcTimeReject().then(function (flag) {
      return flag;
    });
  },

  backtoBizChangeNavi: function backtoBizChangeNavi(_this) {
    var currRoute = _.get(_this, "$store.state.route"),
        fromRoutePath = _.get(_this, "$store.state.route.from.path");
    if (["V0049", "V0126", "V0127"].includes(_.get(_this, "$store.state.busicode"))) {
      if (fromRoutePath.includes("bizCheck")) {
        !currRoute.path.includes("bizChangeNavigation") && _this.$router.goRoute("资料录入");
      }
    } else if (_this.busiCode == "V0115") {
      if (fromRoutePath.includes("bizCheck") && _this.historyData.NODE_CODE < 6) {
        !currRoute.path.includes("bizChangeNavigation") && _this.$router.goRoute("资料录入");
      }
    } else if (_this.busiCode == "V0130") {
      if (fromRoutePath.includes("bizCheck") && _this.historyData.NODE_CODE < 5) {
        !currRoute.path.includes("bizChangeNavigation") && _this.$router.goRoute("资料录入");
      }
    }
  },
  getValidateTip: function getValidateTip(_this, field, fieldData, _ref6) {
    var SEX = _ref6.SEX,
        EDUCATION = _ref6.EDUCATION,
        AGE = _ref6.AGE;

    var workPlaceTip = "",
        ageTip = "",
        educationTip = "";
    if (fieldData.WORKPLACE && field.DEFAULT_VALUE == "21") {
      if (fieldData.WORKPLACE.DEFAULT_VALUE.indexOf("公司") != -1) {
        workPlaceTip = "您的职业为党政机关负责人及管理人员，工作单位填写存在公司字样，请您核实工作单位信息的准确性。";
      } else {
        var showTip = true;
        _.each(["部", "委", "行", "署", "厅", "局", "处", "室", "办", "会", "团", "院", "社", "校", "馆", "中心"], function (s) {
          if (fieldData.WORKPLACE.DEFAULT_VALUE.indexOf(s) != -1) {
            showTip = false;
          }
        });
        if (showTip) {
          workPlaceTip = "需有下列字样：部、委、行、署、厅、局、处、室、办、会、团、院、社、校、馆、中心，请您核实工作单位信息的准确性。";
        }
      }
    }

    if (field.DEFAULT_VALUE == "58") {
      if (SEX == "0" && AGE > 60 || SEX == "1" && AGE > 55) {
        ageTip = "您的年龄大于法定退休年龄，请您核实职业信息是否正确。";
      } else if (AGE >= 30 && !["0", "1"].includes(EDUCATION)) {
        ageTip = "您的年龄大于等于30周岁，且学历为\"本科\"及以下，请您核实职业和学历信息是否正确。";
      } else if (AGE <= 20 && ["0", "1", "2"].includes(EDUCATION)) {
        ageTip = "您的年龄小于等于20周岁、且学历为\"本科\"及以上学历，请您核实学历信息是否正确。";
      }
    } else {
      if (field.DEFAULT_VALUE == "55") {
        if (SEX == "0" && AGE <= 60 || SEX == "1" && AGE <= 55) {
          ageTip = "您的年龄小于或等于法定退休年龄，请您核实职业信息是否正确。";
        }
      } else {
        if (SEX == "0" && AGE > 60 || SEX == "1" && AGE > 55) {
          ageTip = "您的年龄大于法定退休年龄，请您核实职业信息是否正确";
        } else if (AGE < 20) {
          ageTip = "您的年龄不足20周岁，请您核实职业信息是否正确";
        }
      }
      if (["38", "21", "22", "36", "23", "37", "25", "24", "54", "32", "31", "33", "26", "29", "30", "28"].includes(field.DEFAULT_VALUE)) {
        if (EDUCATION == "6") {
          educationTip = "您的学历为初中及以下，请您核实学历及职业信息是否正确";
        }
      }
    }
    return { workPlaceTip: workPlaceTip, ageTip: ageTip, educationTip: educationTip };
  },
  validateOccuTypeLogic: function validateOccuTypeLogic(_this, field, fieldData, module, noClear) {
    fieldData.POSITION.FIELD_DICT_FILTER = "";
    !noClear && (fieldData.POSITION.DEFAULT_VALUE = "");
    fieldData.WORKPLACE.isCheckCheckbox = false;
    !noClear && (fieldData.WORKPLACE.DEFAULT_VALUE = "");
    fieldData.WORKPLACE.FIELD_CONTROL = "0";

    if (["55", "56", "58", "57"].includes(field.DEFAULT_VALUE)) {
      fieldData.WORKPLACE.DEFAULT_VALUE = "无";
      fieldData.WORKPLACE.FIELD_CONTROL = "2";
      fieldData.WORKPLACE.isCheckCheckbox = true;
      _this.$set(fieldData.WORKPLACE, "CHECKBOX_DISABLE", true);
    } else if (["51", "46", "53"].includes(field.DEFAULT_VALUE)) {
      fieldData.WORKPLACE.FIELD_CONTROL = "0";
      _this.$set(fieldData.WORKPLACE, "CHECKBOX_DISABLE", false);
    } else {
      fieldData.WORKPLACE.isCheckCheckbox = false;
      fieldData.WORKPLACE.FIELD_REQUIRED = "1";
      _this.$set(fieldData.WORKPLACE, "CHECKBOX_DISABLE", true);
    }

    if (["21", "22", "23", "25", "24"].includes(field.DEFAULT_VALUE)) {
      fieldData.POSITION.FIELD_DICT_FILTER = ["0", "1"];
    } else if (["56", "55", "58", "57"].includes(field.DEFAULT_VALUE)) {
      fieldData.POSITION.FIELD_DICT_FILTER = "";
      fieldData.POSITION.DEFAULT_VALUE = "Y";
      fieldData.POSITION.FIELD_CONTROL = "2";
    } else {
      fieldData.POSITION.FIELD_DICT_FILTER = "";
      fieldData.POSITION.FIELD_CONTROL = "0";
    }
    if (field.DEFAULT_VALUE == "38") {
      fieldData.POSITION.FIELD_DICT_FILTER = ["0", "1", "2", "Y"];
    }
  },
  getBankSignData: function getBankSignData(_this, params) {
    var proArray = [org.getOrgDataByType("1"), _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS700009",
      CUST_CODE: params.CUST_CODE,
      ALL_FLAG: params.ALL_FLAG || "1"
    }), _this.$syscfg.K_Request("Y3000002", {
      CUST_CODE: params.CUST_CODE
    })];
    return _Promise.all(proArray).then(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 3),
          res0 = _ref8[0],
          res1 = _ref8[1],
          res2 = _ref8[2];

      var bankDataAll = res0 || [],
          bankConfReq = [],
          custBaseInfo = _.get(res2, "Data[0]", {}),
          custBankSignData = _.filter(res1.Data || [], function (o) {
        _.each(bankDataAll, function (v) {
          if (o.EXT_ORG === v.ORG_CODE) {
            o.EXT_ORG_TEXT = v.ORG_NAME;
            o.ORG_CLS = v.ORG_CLS;
          }
        });

        "9" !== o.CONTRACT_STATUS && !_.pluck(bankConfReq, "EXT_ORG").includes(o.EXT_ORG) && bankConfReq.push({
          service: "Y3000015",
          CURRENCY: "0",
          EXT_ORG: o.EXT_ORG,
          INT_ORG: custBaseInfo.INT_ORG || params.INT_ORG || params.ORG_CODE,

          CUBSB_TRD_ID: "1B"
        });
        return "9" !== o.CONTRACT_STATUS;
      });
      return _Promise.all(bankConfReq).then(function (res) {
        _.each(custBankSignData, function (v) {
          var bankConfInfo = {};
          _.each(res, function (obj) {
            if (_.get(obj, "Data[0].EXT_ORG", "") == v.EXT_ORG) {
              bankConfInfo = obj.Data[0];
              return false;
            }
          });
          v.CHK_BANK_PWD = bankConfInfo.CHK_BANK_PWD;
          v.CHK_FUND_PWD = bankConfInfo.CHK_FUND_PWD;
          v.CHK_BANK_ACCT = bankConfInfo.CHK_BANK_ACCT;
          ("0" === v.ID_EXP_DATE || -1 === v.ID_EXP_DATE) && (v.ID_EXP_DATE = "");

          if (!v.CUST_NAME && !v.ID_TYPE && !v.ID_CODE && !v.ID_EXP_DATE) {
            v.CUST_NAME = custBaseInfo.USER_FNAME;
            v.ID_TYPE = custBaseInfo.ID_TYPE;
            v.ID_CODE = custBaseInfo.ID_CODE;
            v.ID_EXP_DATE = custBaseInfo.ID_EXP_DATE;
          }
        });
        return dict.transformDict(custBankSignData, ["CURRENCY", "ORG_CLS", "ID_TYPE"]).then(function (dictData) {
          _this.oppBusiData.custBankSignData = dictData;
          return dictData || [];
        });
      });
    });
  },
  getEffectIdType: function getEffectIdType(userType, str) {
    if (!_.isString(str)) {
      return "";
    }
    var idTypeArr = _.filter(str.split(","), function (v) {
      return userType === v.charAt(0);
    });
    return idTypeArr.join(",");
  },

  getUseMutiBankInfo: function getUseMutiBankInfo(_this) {
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS300521",
      REGKEY_ID: "USE_MUTL_BANKINFO"
    }).then(function (res) {
      var USE_MUTL_BANKINFO = _.get(res, "Data[0].REGKEY_VAL", "");
      _this.oppBusiData.USE_MUTL_BANKINFO = USE_MUTL_BANKINFO;
    });
  },

  syncBankOnSelect: function syncBankOnSelect(rowData, paramObj, fieldData, isSync) {
    var isIdentityCard = ["00", "0J"].includes(paramObj.ID_TYPE);
    if (isSync) {
      if ("1" !== rowData.CHK_BANK_PWD) {
        if ("0" === paramObj.USER_TYPE && isIdentityCard || "1" !== paramObj.USE_MUTL_BANKINFO && "0" !== paramObj.USER_TYPE) {
          return false;
        }
      }

      if ("1" !== paramObj.USE_MUTL_BANKINFO && "14" === rowData.ORG_CLS) {
        return false;
      }

      var isDisEidtBsbInfo = "0" === paramObj.USER_TYPE && isIdentityCard || "1" !== paramObj.USE_MUTL_BANKINFO;
      fieldData.CUST_NAME.FIELD_CONTROL = isDisEidtBsbInfo ? "2" : "0";
      fieldData.CUST_NAME.FIELD_REQUIRED = isDisEidtBsbInfo ? "0" : "1";
      fieldData.ID_TYPE.FIELD_CONTROL = isDisEidtBsbInfo ? "2" : "0";
      fieldData.ID_TYPE.FIELD_REQUIRED = isDisEidtBsbInfo ? "0" : "1";
      fieldData.ID_TYPE.FIELD_DICT_FILTER = this.getEffectIdType("0" === paramObj.USER_TYPE ? "0" : "1", paramObj.EFFECT_ID_TYPE).split(",");
      fieldData.ID_CODE.FIELD_CONTROL = isDisEidtBsbInfo ? "2" : "0";
      fieldData.ID_CODE.FIELD_REQUIRED = isDisEidtBsbInfo ? "0" : "1";
      fieldData.ID_EXP_DATE.FIELD_CONTROL = isDisEidtBsbInfo ? "2" : "0";
      fieldData.ID_EXP_DATE.FIELD_REQUIRED = isDisEidtBsbInfo ? "0" : "1";
    } else {
      fieldData.CUST_NAME.FIELD_CONTROL = "2";
      fieldData.CUST_NAME.FIELD_REQUIRED = "0";
      fieldData.ID_TYPE.FIELD_CONTROL = "2";
      fieldData.ID_TYPE.FIELD_REQUIRED = "0";
      fieldData.ID_CODE.FIELD_CONTROL = "2";
      fieldData.ID_CODE.FIELD_REQUIRED = "0";
      fieldData.ID_EXP_DATE.FIELD_CONTROL = "2";
      fieldData.ID_EXP_DATE.FIELD_REQUIRED = "0";
    }
  },

  updateBankSignInfo: function updateBankSignInfo(paramObj, moduleArr) {
    if ("1" === paramObj.USE_MUTL_BANKINFO && "0" !== paramObj.USER_TYPE) {
      return false;
    }
    _.each(moduleArr, function (module) {
      var fieldData = module.FIELDS;
      paramObj.CUST_NAME && (fieldData.CUST_NAME.DEFAULT_VALUE = paramObj.CUST_NAME);
      paramObj.ID_TYPE && (fieldData.ID_TYPE.DEFAULT_VALUE = paramObj.ID_TYPE);
      paramObj.ID_CODE && (fieldData.ID_CODE.DEFAULT_VALUE = paramObj.ID_CODE);
      paramObj.ID_EXP_DATE && (fieldData.ID_EXP_DATE.DEFAULT_VALUE = paramObj.ID_EXP_DATE);
    });
  },

  isCardIdType: isCardIdType,

  getIdCodeValidType: getIdCodeValidType,

  checkIdTypeRelateFields: function checkIdTypeRelateFields(_this, fieldData, relate) {
    relate = _.isArray(relate) ? relate : [relate];
    var idTypefield = fieldData[relate[0]],
        idCodeField = fieldData[relate[1]],
        idExpField = fieldData[relate[2]];
    if (idTypefield.DEFAULT_VALUE !== "") {
      idCodeField.VALID_TYPE = getIdCodeValidType(idTypefield.DEFAULT_VALUE);

      idExpField && _.set(idExpField, "DEFAULT_VALUE", "");
    }
  },
  validCapital: function validCapital(_this, param) {
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000955",
      USER_FNAME: param.CUST_FNAME || "",
      ID_TYPE: param.ID_TYPE || "",
      ID_CODE: param.ID_CODE || "",
      QUERY_MODE: "SUMQUERY",
      USER_ROLE: "2"
    });
  },
  validateCustCapital: function validateCustCapital(_this, field, capital, val) {
    if (capital && capital.length) {
      _this.oppBusiData.isCheckCapital = "1";
      _this.alert({
        messageText: "您已进行聚安一户通服务签约，不允许进行重要信息变更，请先前往【一户通服务签约/解约】菜单进行解约。",

        confirmBtnTxt: "去处理",
        confirmedAction: function confirmedAction() {
          field.DEFAULT_VALUE = val;
          _this.$router.replace({
            name: "homeCustomer",
            params: {
              busiCode: "V0146",
              menuName: "一户通服务签约/解约",
              userType: _this.userType
            }
          });
        }
      });
    }
  },
  focusOnErrFormItem: function focusOnErrFormItem(busiCode) {
    if (isOpenDigital) {
      var firstErrorFormItem = document.querySelector(".el-form-item.is-error"),
          isAlert = document.querySelector(".sign-loading-wrap--alert");
      if (firstErrorFormItem && _.isEmpty(isAlert)) {
        var errorElName = "errorName" + new Date().getTime();
        "V0120" === busiCode && (firstErrorFormItem = firstErrorFormItem.parentElement.parentElement);
        firstErrorFormItem.setAttribute("name", errorElName);
        vm.$digitalService.guideFormPoint({
          "IS_SPEAK": "1",
          "WRONG_TEXT": "字段填写有误，请确认！"
        }, {
          "action": "wrong",
          "priority": 6,
          "popupViewId": errorElName,
          "popupForce": true
        });
      }
    }
  },
  isManyPeopleUseAddress: function isManyPeopleUseAddress(_this, param) {
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS010126",
      address: param.address,
      certTypeCd: param.ID_TYPE,
      certNo: param.ID_CODE
    }).then(function (res) {
      var data = _.get(res, "Data[0]", {});
      return data.repeatFlag === "1";
    });
  },
  getManyPeopleUseAddressTip: function getManyPeopleUseAddressTip(useAddressFlag, useCorpAddrFlag) {
    var str = "";
    str = "所输" + (useAddressFlag ? "家庭地址" : "") + (useAddressFlag && useCorpAddrFlag ? "、" : "") + (useCorpAddrFlag ? "公司地址" : "") + "已被多人使用，请您确认地址是否输入正确。";
    return str;
  },
  isDisabledLongTime: function isDisabledLongTime(_this, idType, idCode, field) {
    var _this4 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var AGE, TRANSFINITE_AGE;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (field) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              AGE = getCustAge(idCode);
              _context2.next = 5;
              return oppService.getSysCommonParamsFromCacheObjs("TRANSFINITE_AGE");

            case 5:
              TRANSFINITE_AGE = _context2.sent;

              if (["00", "0J"].indexOf(idType) > -1 && AGE <= parseInt(TRANSFINITE_AGE)) {
                _this.$set(field, "disabledLong", true);
                if (field.DEFAULT_VALUE === "30001231") {
                  _this.$set(field, "DEFAULT_VALUE", "");
                }
              } else {
                if (["01", "0b", "0c", "0d", "0s"].indexOf(idType) > -1) {
                  _this.$set(field, "disabledLong", true);
                  if (field.DEFAULT_VALUE === "30001231") {
                    _this.$set(field, "DEFAULT_VALUE", "");
                  }
                } else {
                  _this.$set(field, "disabledLong", false);
                }
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  },
  hotelAddress: function hotelAddress(address) {
    var addhotel1 = "宾馆",
        addhotel2 = "酒店";
    if (address && address.indexOf(addhotel1) > -1 || address.indexOf(addhotel2) > -1) {
      return false;
    }
    return true;
  },
  getSameIdCodeCompare: function getSameIdCodeCompare(_this, params) {
    var partnerTypeArr = ["21", "22", "23", "25a"],
        compareParams = [{
      type: "0",
      typeText: partnerTypeArr.indexOf(params.SZORGTYPE) > -1 ? "执行事务合伙人" : "法定代表人",
      USER_FNAME: params.LEGAL_REP,
      ID_TYPE: params.LEGAL_REP_ID_TYPE,
      ID_CODE: params.LEGAL_REP_ID_CODE,
      ID_EXP_DATE: params.LEGAL_REP_ID_EXP_DATE
    }];
    if (params.ORG_CURRENT_AGENT) {
      compareParams.push({
        type: "1",
        typeText: "代理人",
        USER_FNAME: params.AGENT_INFO && params.AGENT_INFO.USER_FNAME,
        ID_TYPE: params.AGENT_INFO && params.AGENT_INFO.ID_TYPE,
        ID_CODE: params.AGENT_INFO && params.AGENT_INFO.ID_CODE,
        ID_EXP_DATE: params.AGENT_INFO && params.AGENT_INFO.ID_EXP_DATE
      });
    }

    _.each(params.BENEFIT_LIST, function (item) {
      item && compareParams.push({
        type: "2",
        typeText: "受益所有人",
        USER_FNAME: item.BENEFICIARY_NAME,
        ID_TYPE: item.BENEFICIARY_ID_TYPE,
        ID_CODE: item.BENEFICIARY_ID,
        ID_EXP_DATE: item.BENEFICIARY_EXP_DATE
      });
    });

    _.each(params.CONTROL_LIST_0, function (item) {
      item && compareParams.push({
        type: "3",
        typeText: params.USER_TYPE === "2" ? "产品控制人" : "实际控制人",
        USER_FNAME: item.CONTROLER_NAME,
        ID_TYPE: item.CONTROLER_ID_TYPE,
        ID_CODE: item.CONTROLER_ID_NO,
        ID_EXP_DATE: item.CONTROLER_ID_EXP_DATE
      });
    });

    _.each(params.CONTROL_LIST_1, function (item) {
      item && compareParams.push({
        type: "4",
        typeText: "实际控股人",
        USER_FNAME: item.CONTROLER_NAME,
        ID_TYPE: item.CONTROLER_ID_TYPE,
        ID_CODE: item.CONTROLER_ID_NO,
        ID_EXP_DATE: item.CONTROLER_ID_EXP_DATE
      });
    });

    var sameCodeData = [],
        sameCodeDataUniq = [],
        sameCodeArr,
        sameCodeItem;
    for (var i = 0; i < compareParams.length; i++) {
      for (var j = i + 1; j < compareParams.length; j++) {
        if (compareParams[i].type !== compareParams[j].type && compareParams[i].ID_CODE === compareParams[j].ID_CODE && (compareParams[i].USER_FNAME !== compareParams[j].USER_FNAME || compareParams[i].ID_EXP_DATE !== compareParams[j].ID_EXP_DATE)) {
          sameCodeData.push(compareParams[i]);
          sameCodeData.push(compareParams[j]);
        }
      }
    }

    sameCodeDataUniq = _.union(sameCodeData);

    sameCodeArr = _.uniqBy(_.pluck(sameCodeDataUniq, "ID_CODE"));

    var resultArr = [];
    _.each(sameCodeDataUniq, function (item) {
      sameCodeItem = _.filter(sameCodeDataUniq, function (o) {
        return item.ID_CODE === o.ID_CODE && sameCodeArr.includes(item.ID_CODE);
      });

      sameCodeArr = _.filter(sameCodeArr, function (v) {
        return item.ID_CODE !== v;
      });
      sameCodeItem.length && resultArr.push(sameCodeItem);
    });

    var resultTextArr = [];
    resultArr.length && _.each(resultArr, function (obj) {
      var typeText = _.pluck(obj, "typeText");
      resultTextArr.push("[" + typeText + " ]的证件号码相同，但名字或证件有效期不同，请确认所录入的信息是否正确。");
    });
    return resultTextArr;
  },
  getLegalRepRepeatTip: function getLegalRepRepeatTip(_this) {
    var modulePath = _this.userType == "2" ? "groupDatas.MANAGER_INFO.MA_LEGAL_REP" : "groupDatas.ORG_BASIC_INFO.ORG_LEGAL_INFO_MODULE";
    var legalInfoFields = _.get(_this, modulePath + "[0].FIELDS");
    var validLegalrepNameFlag = legalInfoFields.LEGAL_REP_ID_TYPE.DEFAULT_VALUE === "10";
    var idCode = _this.userType == "2" ? _this.groupDatas.CUST_INFO.PRD_IMPORNTANT[0].FIELDS.ID_CODE.DEFAULT_VALUE : _this.groupDatas.ORG_IMPORNTANT_INFO.ORG_IMPORNTANT_INFO_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE;
    if (validLegalrepNameFlag) {
      return _this.$syscfg.K_Request("F0000000", {
        SERVICE_CODE: "QS010133",
        LEGAL_REP: legalInfoFields.LEGAL_REP.DEFAULT_VALUE || "",
        ID_CODE: idCode || ""
      }).then(function (res) {
        var legalRepFlag = _.get(res, "Data[0].repeatFlag", "");
        var tip = "",
            LegalRepTitle = "法定代表人（执行事务合伙人）";

        if (validLegalrepNameFlag && (legalRepFlag == "1" || legalRepFlag == "2")) {
          tip = legalRepFlag == "1" ? "所录入的" + LegalRepTitle + "信息与工商系统不一致，请通过“国家企业信用信息公示系统”网站进行核实。" : "营业执照号[" + idCode + "]在工商系统查询不存在，请通过“国家企业信用信息公示系统”网站进行核实。";
        }
        return tip;
      });
    } else {
      return _Promise.resolve();
    }
  },
  saveIdCardDataInReadCardSuccess: function saveIdCardDataInReadCardSuccess(_this, isCustReadCard, cardData, moudleName) {
    consoleLog("进入了了读卡保存的方法", _JSON$stringify(cardData));
    if (isCustReadCard) {
      _this.$store.commit(_this.$types.UPDATE_CARD_DATA, cardData.cardData);

      _this.$storage.setSession(_this.$definecfg.IMAGE_INFO, _JSON$stringify(_Object$assign({}, {
        frontImage: cardData.saveIdCardPath.frontImage,
        backImage: cardData.saveIdCardPath.backImage,
        faceImage: cardData.saveIdCardPath.faceImage
      }, cardData.saveIdCardPath.initBackImage ? {
        initFrontImage: cardData.saveIdCardPath.initFrontImage,
        initBackImage: cardData.saveIdCardPath.initBackImage
      } : {})));
    } else {
      var _Object$assign4;

      window.IDCARD_DATA = _Object$assign({}, window.IDCARD_DATA, (_Object$assign4 = {}, _defineProperty(_Object$assign4, moudleName + "_ID_CARD_DATA", cardData.cardData), _defineProperty(_Object$assign4, moudleName + "_ID_CARD_PATH", cardData.saveIdCardPath), _Object$assign4));
    }
  },
  getAllCSDCTrdAcctBySysAcct: function getAllCSDCTrdAcctBySysAcct(_this, custSystrdacctInfo) {
    var _this5 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      var reqParam, getCSDCAcctDataBySYSAcct, allAcct;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              reqParam = [];

              _this.oppBusiData.csdcTrdAcctDataInfo = [];

              getCSDCAcctDataBySYSAcct = function getCSDCAcctDataBySYSAcct(_this, TRDACCT, ACCT_TYPE) {
                return _this.$syscfg.K_Request("F0000000", {
                  SERVICE_CODE: "QS4000099",
                  TRDACCT: TRDACCT,
                  ACCT_TYPE: ACCT_TYPE
                });
              };

              _.each(custSystrdacctInfo, function (item) {
                var ACCT_TYPE = "";
                if (_.indexOf(["00", "01", "10", "11"], item.STKBD) > -1 && item.TRDACCT_STATUS != "9") {
                  switch (item.STKBD) {
                    case "00":
                      ACCT_TYPE = "21";
                      break;
                    case "01":
                      ACCT_TYPE = "22";
                      break;
                    case "10":
                      ACCT_TYPE = "11";
                      break;
                    case "11":
                      ACCT_TYPE = "12";
                      break;
                  }
                  reqParam.push(getCSDCAcctDataBySYSAcct(_this, item.TRDACCT, ACCT_TYPE));
                }
              });

              if (!(reqParam.length > 0)) {
                _context3.next = 9;
                break;
              }

              _context3.next = 7;
              return _Promise.all(reqParam).then(function (result) {
                return result;
              }).catch(function (err) {
                consoleLog("通过证券账户查中登证券账户失败", err);
              });

            case 7:
              allAcct = _context3.sent;

              _.each(allAcct, function (acctObj) {
                acctObj.Code == "0" && acctObj.Data && acctObj.Data.length && _this.oppBusiData.csdcTrdAcctDataInfo.push(acctObj.Data[0]);
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  },
  handleBankMobileTip: function handleBankMobileTip(_this, EXT_ORG) {
    var userType = _this.$store.state.usertype,
        busiCode = _this.$store.state.busicode,
        sysConfBank = oppService.getSysCommonParamsFromCacheObjs("NEED_SHOW_MOBILE_TIP_BANK").split(",") || [],
        flowTipObj = {
      key: "bankMobileTip",
      type: "warning",
      title: "\u8BF7\u786E\u4FDD" + (userType !== "2" ? "客户的联系人" : "管理人联系信息里") + "\u7684\u8054\u7CFB\u7535\u8BDD\u5F55\u5165\u79FB\u52A8\u7535\u8BDD\uFF0C\u5426\u5219\u94F6\u884C\u7B7E\u7EA6\u53EF\u80FD\u4F1A\u5931\u8D25!"
    },
        isMatch = EXT_ORG && (_.isString(EXT_ORG) && sysConfBank.includes(EXT_ORG) || _.isArray(EXT_ORG) && _.find(sysConfBank, function (v) {
      return EXT_ORG.includes(v);
    }));
    if (isMatch) {
      if (["V0115", "V0130"].includes(busiCode)) {
        _this.$emit("flowTipClick", _Object$assign({
          flag: "1" }, flowTipObj));
      } else {
        _this.$refs.flowTip && _this.pushFlowTip(flowTipObj);
      }
    } else {
      if (["V0115", "V0130"].includes(busiCode)) {
        _this.$emit("flowTipClick", {
          flag: "0",
          key: "bankMobileTip"
        });
      } else {
        _this.$refs.flowTip && _this.removeFlowTip("bankMobileTip");
      }
    }
  },
  setSignBankInfo: function setSignBankInfo(_this, groupId) {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
        USER_TYPE = custInfo.USER_TYPE,
        ID_TYPE = custInfo.ID_TYPE,
        signBankInfo = _this.groupDatas[groupId].CUST_SYNC_IMPORTANT_INFO[0].FIELDS,
        idTypeArr = USER_TYPE === "0" ? ["00", "01", "0b", "0c", "0d", "0e", "0i", "0j"] : ["10", "11", "12", "13", "14", "19", "1Z"];

    if (_this.busiCode === "V0035") {
      idTypeArr = idTypeArr.concat(["06"]);
      signBankInfo.SYNC_CUST_NAME && (signBankInfo.SYNC_CUST_NAME.FIELD_TITLE = "银证账户名称");
    }
    _.set(_this, "groupDatas." + groupId + ".CUST_SYNC_IMPORTANT_INFO[0].FIELDS.SYNC_ID_TYPE.FIELD_DICT_FILTER", idTypeArr);

    for (var fieldId in signBankInfo) {
      signBankInfo[fieldId].DEFAULT_VALUE = custInfo[fieldId.replace("SYNC_CUST_NAME", "CUST_FNAME").replace("SYNC_", "")];
    }

    if (USER_TYPE === "0" && ["00", "0J"].includes(ID_TYPE)) {
      _.set(_this, "groupDatas." + groupId + ".CUST_SYNC_IMPORTANT_INFO[0].MODULE_CONTROL", "0");
    }
  },
  getSignBankInfo: function getSignBankInfo(_this, groupId) {
    var signBankInfo = _this.groupDatas[groupId].CUST_SYNC_IMPORTANT_INFO[0].FIELDS,
        custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
        USER_TYPE = custInfo.USER_TYPE,
        ID_TYPE = custInfo.ID_TYPE,
        SIGN_BANK_INFO = {};

    for (var fieldId in signBankInfo) {
      SIGN_BANK_INFO[fieldId.replace("SYNC_CUST_NAME", "BSB_USER_FNAME").replace("SYNC", "BSB")] = signBankInfo[fieldId].DEFAULT_VALUE;
    }

    SIGN_BANK_INFO["BSB_CUST_FNAME"] = signBankInfo["SYNC_CUST_NAME"].DEFAULT_VALUE;
    return { SIGN_BANK_INFO: SIGN_BANK_INFO, USER_TYPE: USER_TYPE, ID_TYPE: ID_TYPE };
  },
  updateCustSurveyTip: function updateCustSurveyTip(_this, tipArr) {
    if (_.isUndefined(tipArr) || !tipArr.length) {
      _this.$refs.flowTip && _this.$refs.flowTip.flowTips.map(function (v) {
        if (v.key.includes("custSurveyTip")) {
          _this.removeFlowTip(v.key);
        }
      });
      return;
    }
    tipArr.forEach(function (Message, index) {
      _this.removeFlowTip("custSurveyTip" + index);
    });
    tipArr.forEach(function (Message, index) {
      if (Message.includes("已过期")) {
        _this.pushFlowTip({
          type: "error",
          title: Message,
          key: "custSurveyTip" + index,
          confirmBtnTxt: "去处理",
          confirmedAction: function confirmedAction() {
            _this.$router.replace({
              name: "homeCustomer",
              params: {
                busiCode: "V0010",
                menuName: "客户风险测评",
                userType: "2"
              }
            });
          }
        });
      } else {
        _this.pushFlowTip({
          type: "error",
          title: Message,
          key: "custSurveyTip" + index
        });
      }
    });
  },
  getCustSurveyTip: function getCustSurveyTip(custSurveyObj) {
    var tipArr = [];
    var PROPER_RISK_SURVEY_LVL = oppService.getBusiCommonParamsFromCacheObjs("PROPER_RISK_SURVEY_LVL") || custSurveyObj.PROPER_RISK_SURVEY_LVL;
    var PROPER_INVEST_PRO = oppService.getBusiCommonParamsFromCacheObjs("PROPER_INVEST_PRO") || custSurveyObj.PROPER_INVEST_PRO;
    if (_.isEmpty(custSurveyObj)) {
      return tipArr;
    };
    for (var conId in custSurveyObj) {
      var surveyObj = custSurveyObj[conId];
      switch (conId) {
        case "_110":
          if (!_.isEmpty(surveyObj) && (surveyObj.ERROR_CODE == "-71012" || surveyObj.ERROR_CODE == "-900102" || surveyObj.ERROR_CODE == "-900104")) {
            tipArr.push("您未做风险测评或风险测评已过期，无法办理信用业务，请重新进行风险测评！");
          };
          break;
        case "_986":
          if (!_.isEmpty(surveyObj) && (surveyObj.RATING_LVL == "1" || surveyObj.RATING_LVL == "9")) {
            tipArr.push("您的风险测评等级不满足开通条件，无法办理信用业务！");
          };
          break;
        case "_861":
          if (!_.isEmpty(surveyObj) && surveyObj.INVEST_PRO && !surveyObj.INVEST_PRO.includes(PROPER_INVEST_PRO)) {
            tipArr.push("您的投资品种不满足办理要求，无法办理信用业务！");
          };
          break;
        case "_606":
          if (!_.isEmpty(surveyObj) && surveyObj.RATING_LVL && surveyObj.RATING_LVL < PROPER_RISK_SURVEY_LVL) {
            tipArr.push("您的风险等级不满足办理要求，无法办理信用业务！");
          };
          break;
        case "_12162":
          if (!_.isEmpty(surveyObj) && surveyObj.INVEST_PRO && !surveyObj.INVEST_PRO.includes(PROPER_INVEST_PRO)) {
            tipArr.push("您的投资品种不满足办理要求，无法办理信用业务！");
          };
          break;
        case "_12163":
          if (!_.isEmpty(surveyObj) && surveyObj.RATING_LVL && surveyObj.RATING_LVL < PROPER_RISK_SURVEY_LVL) {
            tipArr.push("您的风险等级不满足办理要求，无法办理信用业务！");
          };
          break;
        case "_12131":
          if (!_.isEmpty(surveyObj) && (surveyObj.ERROR_CODE == "-71012" || surveyObj.ERROR_CODE == "-900102" || surveyObj.ERROR_CODE == "-900104")) {
            tipArr.push("您未做风险测评或风险测评已过期，无法办理信用业务，请先进行风险测评。");
          };
          break;

      }
    };
    return tipArr;
  },
  getSurveyDate: function getSurveyDate(_this, busiCode) {
    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
        userInfo = _this.$storage.getJsonSession(_this.$definecfg.USER_INFO),
        urlParam = _Object$assign({}, customerInfo, userInfo),
        intorg = urlParam && urlParam.INT_ORG ? urlParam.INT_ORG : "";
    var innerBusiCode = _this.busiCode || busiCode;
    var param = {
      CUST_CODE: urlParam.CUST_CODE,
      USER_TYPE: urlParam.USER_TYPE,
      BUSI_CODE: innerBusiCode,
      INT_ORG: intorg,
      IS_CREDIT_ACCT: urlParam.USER_TYPE === "2" && innerBusiCode === "V0154" ? "1" : ""
    };
    return custService.getCustSurveyData(param);
  },
  checkCustInfoEcifErrorTip: function checkCustInfoEcifErrorTip(_this, errorList) {
    var flowTips = _this.$refs.flowTip.flowTips;
    flowTips.forEach(function (_ref9) {
      var key = _ref9.key;

      key.startsWith("ECIF") && _this.$refs.flowTip.removeFlowTip(key);
    });

    if (!!errorList.length) {
      errorList.forEach(function (item) {
        _this.$refs.flowTip.pushFlowTip({
          key: item.ruleCode,
          type: "error",
          title: item.ruleDesc
        });
      });
      document.querySelector(".bizEntry-main").scrollTop = 0;
      return false;
    } else {
      return true;
    }
  },
  checkCustInfoEcifMsgList: function checkCustInfoEcifMsgList(_this, msgList) {
    var tipArr = [];
    var errorMsgFlag = false;
    tipArr = msgList.map(function (msg) {
      msg.controlType === "1" && (errorMsgFlag = true);
      return {
        RESTRICT_TYPE: msg.controlType === "1" ? "1" : "2",
        HANDLE_TIP: msg.ruleDesc
      };
    }).sort(function (next, pre) {
      return +next.RESTRICT_TYPE - +pre.RESTRICT_TYPE;
    });
    if (!!tipArr.length) {
      return new _Promise(function (resolve) {
        _this.popup({
          popupType: "cancelCreditCheck",
          confirmButtonText: errorMsgFlag ? "" : "继续提交",
          cancelButtonText: "返回修改",
          hideCloseBtn: true,
          popupInner: {
            title: "字段检核结果",
            listData: tipArr,
            showPreCheckList: true,
            hideSubtitle: true
          },
          confirmedAction: function confirmedAction() {
            resolve(true);
          },
          canceledAction: function canceledAction() {
            resolve(false);
          }
        });
      });
    } else {
      return true;
    }
  },
  commonEcifMethod: function commonEcifMethod(param) {
    var busiData = param.busiData || {},
        isGetChangeDataFlag = param.isGetChangeDataFlag,
        USER_TYPE = busiData.USER_TYPE || "0",
        nodeArr = {
      "0": [],
      "1": ["orgInfo", "otherInfo"].concat(isGetChangeDataFlag ? [] : ["agentInfo"]),
      "2": ["baseInfo", "managerInfo"].concat(isGetChangeDataFlag ? [] : ["agentInfo"])
    },
        handleNodeArr = param.nodeArr || nodeArr[USER_TYPE],
        nodeData = param.nodeData ? param.nodeData : busiData,
        vtmBusiData = _Object$assign({}, isGetChangeDataFlag ? { CUST_CODE: busiData.CUST_CODE } : {}, nodeData),
        ecifParamObject = {},
        paramArr = ["CONTROL_LIST_1", "BENEFIT_LIST", "controllerInfoDtoList", "beneficiaryInfoList"],
        oneRelationMore = {
      taxNo: ["BUSINESS_TAX_NO", "LAND_TAX_NO"]
    };

    _.each(handleNodeArr, function (node) {
      var paramRelationship = ecifParamRelationship[Number(USER_TYPE)][node];
      _.each(paramRelationship, function (ecif, vtm, ecifSelf) {
        if (oneRelationMore.hasOwnProperty(ecif)) {
          ecifParamObject[ecif] = ecifParamObject[ecif] ? ecifParamObject[ecif] : vtmBusiData[vtm] || "";
        } else if (paramArr.indexOf(vtm) === -1) {
          ecifParamObject[ecif] = vtmBusiData[vtm];
        } else if (!_.isEmpty(ecif)) {
          var list = [];

          _.each(vtmBusiData[vtm], function (item) {
            var obj = {};
            _.each(ecifSelf[ecif], function (ecif1, vtm1) {
              obj[ecif1] = item[vtm1] || "";
            });
            !_.isEmpty(obj) && list.push(obj);
          });
          list.length && (ecifParamObject[ecif] = list);
        }
      });
    });
    return _Object$assign({}, ecifParamObject, { uerCode: busiData.CUST_CODE || "" });
  },
  getFieldDefalutValue: function getFieldDefalutValue(fieldModule) {
    var nodeData = {};
    _.each(fieldModule, function (model, key) {
      if (_.isArray(model)) {
        var tempArr = [];
        _.each(model, function (value) {
          var obj = {};
          var fields = value.FIELDS;
          _.each(fields, function (value, key) {
            obj[key] = value.DEFAULT_VALUE;
          });
          tempArr.push(obj);
        });
        nodeData[key] = tempArr;
      } else {
        _.each(model, function (value, key) {
          nodeData[key.replace("USER_FNAME", "CUST_FNAME").replace("SZORGTYPE", "SZORG_TYPE")] = value.DEFAULT_VALUE;
        });
      }
    });
    return nodeData;
  },

  openBizEcifCheck: function openBizEcifCheck(_this, fieldModule, nodeArr) {
    var tempObj = {};
    _.each(fieldModule, function (model, key) {
      tempObj[key] = _.get(_this, model, {});
    });
    var nodeData = _this.$blMethod.getFieldDefalutValue(tempObj);
    var busi_info = _this.$storage.getJsonSession(_this.$definecfg.BUSI_INFO) || {};

    var ecifRes = _this.$blMethod.commonEcifMethod({ busiData: busi_info, nodeArr: nodeArr, nodeData: nodeData });
    return custService.checkCustInfo({ userType: busi_info.USER_TYPE, busType: "1", userData: ecifRes }, true);
  },
  forceIntoDoubleRecord: function forceIntoDoubleRecord(_this, routerName) {
    var tables = _.cloneDeep(_this.$store.state.bizRouteTable);
    if (_.find(tables, { name: "照片上传" }) && !_.find(tables, { path: "/imageAcquisition/videoCollection" })) {
      _this.$router.addRoute(_this.$router.getRouteIndex(routerName) + 1, {
        name: "双录",
        path: "/imageAcquisition/videoCollection"
      });
      _this.$router.addRoute(_this.$router.getRouteIndex(routerName) + 2, {
        name: "双录",
        path: "/imageAcquisition/localRecord"
      });
    }
  },
  isShowCustRecheckNode: function isShowCustRecheckNode(_this) {
    var IS_SHOW_CUST_RECHECK_NODE = oppService.getBusiCommonParamsFromCacheObjs("IS_SHOW_CUST_RECHECK_NODE");
    var currentRoute = _this.$router.getCurrentRoute();
    var isSelectPermissionBusi = void 0,
        isShowCustRecheckNode = void 0;
    if (_this.busiCode === "V0148") {
      var agmtTypeArr = _this.oppBusiData.AGMT_TYPE_ARR || [];
      isSelectPermissionBusi = _.some(_.get(_this, "bizData.PERM_DATA", {}), function (item) {
        return agmtTypeArr.includes(item.CUST_AGMT_TYPE);
      });
    }
    isShowCustRecheckNode = _this.busiCode === "V0148" ? IS_SHOW_CUST_RECHECK_NODE === "1" && isSelectPermissionBusi : IS_SHOW_CUST_RECHECK_NODE === "1";
    if (isShowCustRecheckNode) {
      _this.$router.showRoute("客户回访");
    } else {
      _this.$router.hideRoute("客户回访");
    }
  },
  getDealParam: function getDealParam(_this) {
    var bSno = _this.$storage.getSession(_this.$definecfg.B_SNO);
    if (!bSno) {
      return false;
    };
    return _this.$syscfg.K_Request("F0000036", { B_SNO: bSno }).then(function (res) {
      var bizData = _.get(res, "Data[0]", {});
      var dealParam = !!bizData.DEAL_PARAM && JSON.parse(decodeURIComponent(bizData.DEAL_PARAM)) || {};
      return dealParam;
    }).catch(function (err) {
      consoleLog("getDealParam-获取受理参数接口报错，原因：" + err);
    });
  },
  isTradeDay: function isTradeDay(_this, d) {
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "Y3000001",
      LBM: "L1260601",
      PHYSICAL_DATE: d || date.formatDate(new Date(), "yyyyMMdd")
    }).then(function (res) {
      if (res.Code == "0") {
        return res.Data[0] && res.Data[0].DATE_FLAG;
      }
    }).catch(function (err) {
      consoleLog("isTradeDay-判断日期是否为交易日接口报错，原因：" + err);
    });
  },
  queryCsdcSzUnQuali: function queryCsdcSzUnQuali(_this, params) {
    var _this6 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
      var isInCsdcTime, csdcTrdacctList, szCsdcTrdacctList, loading, custFname, idType, idCode, trdacctListSz, csdcQueryList;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isInCsdcTime = params.IS_IN_CSDC, csdcTrdacctList = params.CSDC_TRDACCT_LIST, szCsdcTrdacctList = [], loading = params.loading, custFname = params.CUST_FNAME, idType = params.ID_TYPE, idCode = params.ID_CODE;
              trdacctListSz = csdcTrdacctList.filter(function (v) {
                return ["21", "22"].includes(v.ACCT_TYPE);
              });

              if (!(!trdacctListSz.length || !isInCsdcTime)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return", []);

            case 4:

              loading && _this.myLoading("正在查询证券账户关联关系确认");
              csdcQueryList = [];

              trdacctListSz.map(function (v) {
                csdcQueryList.push(csdcService.getCSDCTrdacctData({
                  CUST_FNAME: custFname,
                  ID_TYPE: idType === "0J" ? "00" : idType,
                  ID_CODE: idCode,
                  ACCTBIZ_EXCODE: "26",
                  ACCTBIZ_CLS: "03",
                  TRDACCT: v.TRDACCT,
                  ACCT_TYPE: v.ACCT_TYPE
                }));
              });
              _context4.next = 9;
              return _Promise.all(csdcQueryList).then(function (szCsdcTrdacct) {
                return _.flatten(szCsdcTrdacct);
              }).catch(function (err) {
                consoleLog("查询证券账户不合格出错", err);
              });

            case 9:
              szCsdcTrdacctList = _context4.sent;

              loading && _this.myLoading({ showLoading: false });

              return _context4.abrupt("return", szCsdcTrdacctList);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }))();
  },
  isExistRelation: function isExistRelation(_this, params) {
    var _this7 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee5() {
      var that, isInCsdcTime, csdcTrdacctList, szCsdcTrdacctList, getNotRelaList, trdacctList, relationFlag;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              that = _this7, isInCsdcTime = params.IS_IN_CSDC, csdcTrdacctList = params.CSDC_TRDACCT_LIST, szCsdcTrdacctList = [];

              getNotRelaList = function getNotRelaList(csdcTrdacctList) {
                return _.filter(csdcTrdacctList, function (v) {
                  var flag = "1" === v.RELATION_FLAG || v.ACCT_TYPE === "14" || v.ACCT_TYPE === "15" || v.ACCT_TYPE === "24" || v.ACCT_TYPE === "25" || v.ACCT_TYPE === "13" || v.ACCT_TYPE === "23" || v.UNQUALI_FLAG == "1",
                      startFlag = v.TRDACCT.startsWith("A99");
                  return !flag && _.indexOf(["0", "5", "6"], v.ACCT_STATUS) > -1 && !startFlag;
                });
              };

              trdacctList = getNotRelaList(csdcTrdacctList);
              relationFlag = false;

              if (isInCsdcTime) {
                _context5.next = 7;
                break;
              }

              relationFlag = !_.isEmpty(trdacctList);
              return _context5.abrupt("return", relationFlag);

            case 7:
              relationFlag = !_.isEmpty(_.find(trdacctList, function (v) {
                return !["21", "22"].includes(v.ACCT_TYPE) && v.UNQUALI_FLAG == "0";
              }));

              if (relationFlag) {
                _context5.next = 15;
                break;
              }

              _context5.next = 11;
              return that.queryCsdcSzUnQuali(_this, params);

            case 11:
              szCsdcTrdacctList = _context5.sent;

              if (szCsdcTrdacctList.length) {
                csdcTrdacctList.map(function (trdacct) {
                  var matchTrdacct = _.find(szCsdcTrdacctList, { TRDACCT: trdacct.TRDACCT, ACCT_TYPE: trdacct.ACCT_TYPE });
                  if (!_.isEmpty(matchTrdacct)) {
                    trdacct.UNQUALI_FLAG = matchTrdacct.UNQUALI_FLAG;
                  }
                  return trdacct;
                });
              }
              trdacctList = getNotRelaList(csdcTrdacctList);
              relationFlag = !_.isEmpty(trdacctList);

            case 15:
              return _context5.abrupt("return", relationFlag);

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  },
  autoFillThreePointData: function autoFillThreePointData(_this, field, fieldData, rowData, infoPath) {
    if (field.DEFAULT_VALUE === "1") {
      _.set(fieldData, "CUST_NAME.DEFAULT_VALUE", _.get(_this, infoPath + "[0].FIELDS.USER_FNAME.DEFAULT_VALUE", ""));
      _.set(fieldData, "ID_TYPE.DEFAULT_VALUE", _.get(_this, infoPath + "[0].FIELDS.ID_TYPE.DEFAULT_VALUE", ""));
      _.set(fieldData, "ID_CODE.DEFAULT_VALUE", _.get(_this, infoPath + "[0].FIELDS.ID_CODE.DEFAULT_VALUE", ""));
      _.set(fieldData, "ID_EXP_DATE.DEFAULT_VALUE", _.get(_this, infoPath + "[0].FIELDS.ID_EXP_DATE.DEFAULT_VALUE", ""));
    } else {
      _.set(fieldData, "CUST_NAME.DEFAULT_VALUE", _.get(rowData, "CUST_NAME", ""));
      _.set(fieldData, "ID_TYPE.DEFAULT_VALUE", _.get(rowData, "ID_TYPE", ""));
      _.set(fieldData, "ID_CODE.DEFAULT_VALUE", _.get(rowData, "ID_CODE", ""));
      _.set(fieldData, "ID_EXP_DATE.DEFAULT_VALUE", _.get(rowData, "ID_EXP_DATE", ""));
    }
  },

  getFirstWithIgnorePageIndex: function getFirstWithIgnorePageIndex(_this) {
    var bizRouteTable = _this.$store.state.bizRouteTable;
    for (var i = 0; i < bizRouteTable.length; i++) {
      if (bizRouteTable[i].show && !bizRouteTable[i].ignorePrev) {
        return i;
      }
    }
    return -1;
  },

  queryCSDCTimeAndTradeDay: function queryCSDCTimeAndTradeDay(_this, sysCode) {
    var code = sysCode || "11";
    return _Promise.all([csdcService.queryCSDCTime(code), this.isTradeDay(_this)]).then(function (res) {
      var isCSDCTime = res[0] === "true",
          isTradeDay = res[1] === "1";
      return isCSDCTime && isTradeDay;
    }).catch(function (err) {
      consoleLog("queryCSDCTimeAndTradeDay 判断是否为中登服务时间且为交易日报错：", err);
    });
  },
  isShowAgmtNode: function isShowAgmtNode(_this, TRDACCT_INFO_LIST, isneedAgmtRechectNode) {
    var isShowAgmtNode = false;
    TRDACCT_INFO_LIST.length && _.each(TRDACCT_INFO_LIST, function (v) {
      (v.OP_TYPE == "$SZA" || v.OP_TYPE == "$SHA") && (isShowAgmtNode = true);
    });
    if (isShowAgmtNode) {
      _this.$router.showRoute("权限选择");
      if (isneedAgmtRechectNode && isneedAgmtRechectNode == "1") {
        _this.$router.showRoute("权限开通回访");
      } else {
        _this.$router.hideRoute("权限开通回访");
      }
    } else {
      _this.$router.hideRoute("权限选择");
      _this.$router.hideRoute("权限开通回访");
    }
    _this.oppBusiData.isShowAgmtNode = isShowAgmtNode;
  },

  checkLinkManInfoIsPerfect: function checkLinkManInfoIsPerfect(_this, isAddModule) {
    var custOtherLinkInfo = _.cloneDeep(_.get(_this, "groupDatas.CUST_LINK_INFO.CUST_OTHER_LINK_INFO", [])),
        linkInfoImperfectMessage = "";
    var checkLinkManDefaultValue = function checkLinkManDefaultValue(fields) {
      return _.some(fields, function (value, key) {
        return key !== "LINKMAN_FLAG" && value.FIELD_CONTROL === "0" && !_.isEmpty(value.DEFAULT_VALUE);
      });
    };
    custOtherLinkInfo.find(function (linkMan) {
      var fields = linkMan.FIELDS,
          moduleNum = +linkMan.MODULE_NUM + 1;
      var message = "\u7B2C\u3010" + moduleNum + "\u3011\u6761\u8054\u7CFB\u4EBA\u4FE1\u606F\u4E0D\u5B8C\u5584,";

      if (!_.isEmpty(fields.LINKMAN_FLAG.DEFAULT_VALUE)) {
        !checkLinkManDefaultValue(fields) && (linkInfoImperfectMessage = message + "请完善联系人信息!");
      } else {
        checkLinkManDefaultValue(fields) && (linkInfoImperfectMessage = message + "请选择联系人标识!");

        (custOtherLinkInfo.length > 1 || isAddModule) && !checkLinkManDefaultValue(fields) && (linkInfoImperfectMessage = message + "请完善联系人信息!");
      };
      return linkInfoImperfectMessage;
    });
    return linkInfoImperfectMessage;
  },

  openBusiAndCustInfoChangeIsCollectXbf: function openBusiAndCustInfoChangeIsCollectXbf(_this, module, newBankDataGroup, initBankData) {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
        busiCode = _this.busiCode,
        IS_NEED_COLLECT_Xbf = "0";
    var compareBsBInfo = function compareBsBInfo(compareArr) {
      return _.some(newBankDataGroup, function (moduleObj) {
        var initBankSignData = {},
            newBankSignData = {};
        compareArr.forEach(function (field) {
          newBankSignData[field] = moduleObj[field];
        });
        initBankSignData = _.find(initBankData, function (v) {
          return moduleObj.EXT_ORG == v.EXT_ORG;
        }) || {};
        return !_.isMatch(initBankSignData, newBankSignData);
      });
    };
    try {
      if (_this.$syscfg.isPersonOpenAcctBiz(busiCode)) {
        IS_NEED_COLLECT_Xbf = ["00", "0J"].includes(custInfo.ID_TYPE) ? "0" : "1";
      } else if (_this.$syscfg.isOrgOpenAcctBiz(busiCode)) {
        var bsbMdValObj = this.parseFieldsToObj(_.get(_this, "" + module), "DEFAULT_VALUE");
        IS_NEED_COLLECT_Xbf = _.some(["BSB_USER_FNAME", "BSB_ID_TYPE", "BSB_ID_CODE"], function (field) {
          return bsbMdValObj[field] !== custInfo[field.replace("BSB_", "").replace("USER_FNAME", "CUST_FNAME")];
        }) ? "1" : "0";
      } else if (["V0126", "V0127"].includes(busiCode)) {
        IS_NEED_COLLECT_Xbf = compareBsBInfo(["CUST_NAME", "ID_TYPE", "ID_CODE"]) ? "1" : "0";
      } else if ("V0049" === busiCode) {
        var idType = _.get(_this, module + ".DEFAULT_VALUE");
        IS_NEED_COLLECT_Xbf = !["00", "0J"].includes(idType) && compareBsBInfo(["CUST_NAME", "ID_CODE"]) ? "1" : "0";
      };
    } catch (err) {
      consoleError("判断是否需要采集Xbf-银证账户开户证明文件:", err);
    }
    return { IS_NEED_COLLECT_Xbf: IS_NEED_COLLECT_Xbf };
  },

  invoke: function invoke(nodeList, funcName) {
    var _this = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var args = arguments[3];

    _.each(nodeList, function (node) {
      if (_this.moduleId && _this.moduleId.includes(node.getModuleId && node.getModuleId())) {
        node[funcName] && node[funcName].apply(_this, args);
      }
    });
  },
  getPromiseArr: function getPromiseArr(nodeList, funcName) {
    var _this = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var args = arguments[3];

    var arr = [];
    _.each(nodeList, function (node) {
      if (node[funcName]) {
        arr.push(node[funcName].apply(_this, args));
      }
    });
    return arr;
  },
  getPromiseArrWithFilter: function getPromiseArrWithFilter(nodeList, funcName) {
    var _this = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var args = arguments[3];
    var filterFunc = arguments[4];

    var filteredNodeList = filterFunc(_this, nodeList);
    return this.getPromiseArr(filteredNodeList, funcName, _this, args);
  },
  invokeWithFilter: function invokeWithFilter(nodeList, funcName) {
    var _this = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var args = arguments[3];
    var filterFunc = arguments[4];

    var filteredNodeList = filterFunc(_this, nodeList);
    return this.invoke(filteredNodeList, funcName, _this, args);
  },
  getSanctionList: function getSanctionList(_this, monitorParam) {
    _this.$store.commit(_this.$types.UPDATE_LOADING, "正在进行监控名单查询...");
    return _this.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS300500",
      USER_TYPE: _this.userType || "",
      OPEN_ACCOUNT_MONITOR_LIST: monitorParam || []
    }).then(function (sanctionObj) {
      var flag = true,
          SanctionPepList = [],
          sanctionList = [];

      _.each(sanctionObj, function (item) {
        if (item.CASE_LEVEL && item.CASE_LEVEL !== "pep") {
          sanctionList.push(item);
          flag = false;
        }
        if (item.CASE_LEVEL === "pep") {
          SanctionPepList.push(item);
          flag = false;
        }
      });

      sanctionList = _.uniqBy(sanctionList, "CUST_NAME");
      SanctionPepList = _.uniqBy(SanctionPepList, "CUST_NAME");
      if (!flag) {
        if (sanctionList.length) {
          var nameStr = "[";
          _.each(sanctionList, function (sanction) {
            nameStr += sanction.CUST_NAME + ",";
          });
          nameStr = nameStr.substring(0, nameStr.length - 1);
          nameStr = nameStr + "]";
          _this.alert(nameStr + "在反恐融资制裁名单中，不允许办理开户");
        }

        if (SanctionPepList.length) {
          var _nameStr = "[";
          _.each(SanctionPepList, function (sanction) {
            _nameStr += sanction.CUST_NAME + ",";
          });
          _nameStr = _nameStr.substring(0, _nameStr.length - 1);
          _nameStr = _nameStr + "]";
          _this.alert(_nameStr + "疑似为政治公众人物（PEP），不允许通过VTM办理开户，请到人工柜台办理！");
        }
      }
      _this.$store.commit(_this.$types.UPDATE_LOADING, false);
      return flag;
    });
  },
  checkAddress: function checkAddress(address) {
    var addStr = address && address.slice(address.length - 1),
        addArr = ["号", "户", "室", "组"];
    if (address && addArr.indexOf(addStr) < 0) {
      return false;
    }
    return true;
  },
  diabledFieldCheck: function diabledFieldCheck(_this) {
    _this.$router.updateRoute(_this.$router.getCurrentRouteIndex(), "ignoreFieldCheck", true);
  },
  enableFieldCheck: function enableFieldCheck(_this) {
    _this.$router.updateRoute(_this.$router.getCurrentRouteIndex(), "ignoreFieldCheck", false);
    _this.runFieldRules();
  },
  backFillCsdcInfo: function backFillCsdcInfo(_this, csdcInfo, flag) {
    var fieldConfig = {
      "CUST_NAME": "ORG_SIMPLE_NAME",
      "SZORG_TYPE": "ORGANIZATION_CLS",
      "ID_ZIP_CODE": "ZIP_CODE",
      "LINKMAN_ID": "LINKMAN_ID_CODE"
    };
    !flag && _this.$blMethod.diabledFieldCheck(_this);

    _Object$keys(_this.groupDatas).forEach(function (page) {
      _Object$keys(_this.groupDatas[page]).forEach(function (md) {
        if (md == "AGENT_MODULE" || md == "AGENT_LINK_MODULE" || md == "MA_CUST_TAX_INFO_MODULE" || md == "MA_CONTROLER_TAX_INFO_MODULE") {
          return true;
        }
        _Object$keys(_this.groupDatas[page][md][0]["FIELDS"]).forEach(function (fieldItem) {
          var item = _this.groupDatas[page][md][0]["FIELDS"][fieldItem];
          var fieldId = fieldConfig[item.FIELD_ID] ? fieldConfig[item.FIELD_ID] : item.FIELD_ID;
          if (csdcInfo[fieldId] && csdcInfo[fieldId] != "0") {
            if (flag) {
              if (!item.DEFAULT_VALUE) {
                item.DEFAULT_VALUE = csdcInfo[fieldId];
                _this.$nextTick(function () {
                  item.DATA_SOURCE = 3;
                });
              }
            } else {
              item.DEFAULT_VALUE = csdcInfo[fieldId];
              _this.$nextTick(function () {
                item.DATA_SOURCE = 3;
              });
            }
            if (_this.userType == "1" && item.FIELD_ID == "SZORG_TYPE" && item.FIELD_DICT_FILTER.indexOf(item.DEFAULT_VALUE) == -1) {
              item.DEFAULT_VALUE = "";
            }
          }
        });
      });
    });
    if (!flag) {
      setTimeout(function () {
        _this.$blMethod.enableFieldCheck(_this);
      }, 1000);
    }
  },
  backFillCompanyInfo: function backFillCompanyInfo(_this, basicInfo) {
    if (_this.userType == "1") {

      var basicModule = _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS,
          fieldData = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS;
      _this.oppBusiData.hideFields.ORG_ID_CODE = {
        value: basicInfo.orgnum,
        DATA_SOURCE: "2"
      };
      if (basicInfo.fenNm && _this.$store.state.openAcctType != 3) {
        if (!_this.oppBusiData.hideFields.ORG_ENGLISH_NAME) {
          _this.oppBusiData.hideFields.ORG_ENGLISH_NAME = {
            value: basicInfo.fenNm,
            DATA_SOURCE: "2"
          };
        }
      }

      if (!fieldData.CUST_FNAME.DEFAULT_VALUE && basicInfo.companyNm) {
        fieldData.CUST_FNAME.DEFAULT_VALUE = basicInfo.companyNm;
        fieldData.CUST_FNAME.DATA_SOURCE = "2";
      }

      if (!fieldData.CUST_NAME.DEFAULT_VALUE && basicInfo.companySnm && _this.$store.state.openAcctType && _this.$store.state.openAcctType != 3) {
        fieldData.CUST_NAME.DEFAULT_VALUE = basicInfo.companySnm;
        fieldData.CUST_NAME.DATA_SOURCE = "2";
      }
      if (!fieldData.BIRTHDAY.DEFAULT_VALUE && basicInfo.foundDt) {
        fieldData.BIRTHDAY.DEFAULT_VALUE = basicInfo.foundDt.split("T")[0].replaceAll("-", "");
        fieldData.BIRTHDAY.DATA_SOURCE = "2";
      }
      if (!fieldData.ID_EXP_DATE.DEFAULT_VALUE && basicInfo.endDt) {
        fieldData.ID_EXP_DATE.DEFAULT_VALUE = basicInfo.endDt.split("T")[0].replaceAll("-", "");;
        fieldData.ID_EXP_DATE.DATA_SOURCE = "2";
      }
      if (!fieldData.ID_BEG_DATE.DEFAULT_VALUE && basicInfo.startDt) {
        fieldData.ID_BEG_DATE.DEFAULT_VALUE = basicInfo.startDt;
        fieldData.ID_BEG_DATE.DATA_SOURCE = "2";
      }
      if (!basicModule.REGISTER_CURRENCY.DEFAULT_VALUE && basicInfo.currency) {
        if (basicInfo.currency == "RMB") {
          basicModule.REGISTER_CURRENCY.DEFAULT_VALUE = "CNY";
        } else {
          basicModule.REGISTER_CURRENCY.DEFAULT_VALUE = basicInfo.currency;
        }
        basicModule.REGISTER_CURRENCY.DATA_SOURCE = "2";
      }
      if (!fieldData.BUSINESS_RANGE.DEFAULT_VALUE && basicInfo.businScope) {
        fieldData.BUSINESS_RANGE.DEFAULT_VALUE = basicInfo.businScope;
        fieldData.BUSINESS_RANGE.DATA_SOURCE = "2";
      }
      if (!basicModule.REGISTER_FUND.DEFAULT_VALUE && basicInfo.regCapital) {
        basicModule.REGISTER_FUND.DEFAULT_VALUE = basicInfo.regCapital * 10000 + "";
        basicModule.REGISTER_FUND.DATA_SOURCE = "2";
      }
      if (!basicModule.LISTED_ATTR.DEFAULT_VALUE && basicInfo.isList && _this.userType == "1") {
        basicModule.LISTED_ATTR.DEFAULT_VALUE = basicInfo.isList + "";
        basicModule.LISTED_ATTR.DATA_SOURCE = "2";
      }
      if (!basicModule.CORP_ADDR.DEFAULT_VALUE && basicInfo.officeAddr) {
        basicModule.CORP_ADDR.DEFAULT_VALUE = basicInfo.officeAddr;
        basicModule.CORP_ADDR.DATA_SOURCE = "2";
      }
      if (!basicModule.ID_ZIP_CODE.DEFAULT_VALUE && basicInfo.officePostCd) {
        basicModule.ID_ZIP_CODE.DEFAULT_VALUE = basicInfo.officePostCd;
        basicModule.ID_ZIP_CODE.DATA_SOURCE = "2";
      }
      if (basicInfo.fenNm) {
        if (_this.userType == "1") {
          if (!_this.oppBusiData.hideFields.ORG_ENGLISH_NAME) {
            _this.oppBusiData.hideFields.ORG_ENGLISH_NAME = {
              value: basicInfo.fenNm,
              DATA_SOURCE: "2"
            };
          }
        } else {
          if (!_this.oppBusiData.hideFields.PRO_MANAGER_ENNAME) {
            _this.oppBusiData.hideFields.PRO_MANAGER_ENNAME = {
              value: basicInfo.fenNm,
              DATA_SOURCE: "2"
            };
          }
        }
      }
      if (!fieldData.ID_ADDR.DEFAULT_VALUE && basicInfo.regAddr) {
        fieldData.ID_ADDR.DEFAULT_VALUE = basicInfo.regAddr;
        fieldData.ID_ADDR.DATA_SOURCE = "2";
      }
      if (!basicModule.CITIZENSHIP.DEFAULT_VALUE && basicInfo.country) {
        basicModule.CITIZENSHIP.DEFAULT_VALUE = basicInfo.country;
        basicModule.CITIZENSHIP.DATA_SOURCE = "2";
      }
    } else if (_this.userType == "2") {
      var _basicModule = _this.groupDatas.MANAGER_INFO_PAGE.MANAGER_OTHER_INFO[0].FIELDS;
      var linkModule = _this.groupDatas.OTHER_INFO_PAGE.LINK_MODULE[0].FIELDS;
      var _fieldData = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS;
      if (basicInfo) {
        _this.oppBusiData.companyBasicInfo = basicInfo;
        _this.oppBusiData.basicInfo = basicInfo;
        _this.oppBusiData.hideFields.ORG_ID_CODE = {
          value: basicInfo.orgnum,
          DATA_SOURCE: "2"
        };
        if (basicInfo.fenNm && _this.$store.state.openAcctType != 3) {
          if (!_this.oppBusiData.hideFields.ORG_ENGLISH_NAME) {
            _this.oppBusiData.hideFields.ORG_ENGLISH_NAME = {
              value: basicInfo.fenNm,
              DATA_SOURCE: "2"
            };
          }
        }
        if (!_basicModule.BIRTHDAY.DEFAULT_VALUE && basicInfo.foundDt) {
          _basicModule.BIRTHDAY.DEFAULT_VALUE = basicInfo.foundDt.split("T")[0].replaceAll("-", "");
          _basicModule.BIRTHDAY.DATA_SOURCE = "2";
        }
        if (!_fieldData.ID_EXP_DATE.DEFAULT_VALUE && basicInfo.endDt) {
          _fieldData.ID_EXP_DATE.DEFAULT_VALUE = basicInfo.endDt.split("T")[0].replaceAll("-", "");;
          _fieldData.ID_EXP_DATE.DATA_SOURCE = "2";
        }
        if (!_fieldData.ID_BEG_DATE.DEFAULT_VALUE && basicInfo.startDt) {
          _fieldData.ID_BEG_DATE.DEFAULT_VALUE = basicInfo.startDt;
          _fieldData.ID_BEG_DATE.DATA_SOURCE = "2";
        }
        if (!_basicModule.CURRENCY.DEFAULT_VALUE && basicInfo.currency) {
          if (basicInfo.currency == "RMB") {
            _basicModule.CURRENCY.DEFAULT_VALUE = "CNY";
          } else {
            _basicModule.CURRENCY.DEFAULT_VALUE = basicInfo.currency;
          }
          _basicModule.CURRENCY.DATA_SOURCE = "2";
        }
        if (!_fieldData.BUSINESS_RANGE.DEFAULT_VALUE && basicInfo.businScope) {
          _fieldData.BUSINESS_RANGE.DEFAULT_VALUE = basicInfo.businScope;
          _fieldData.BUSINESS_RANGE.DATA_SOURCE = "2";
        }
        if (!_basicModule.REGISTER_FUND.DEFAULT_VALUE && basicInfo.regCapital) {
          _basicModule.REGISTER_FUND.DEFAULT_VALUE = basicInfo.regCapital * 10000 + "";
          _basicModule.REGISTER_FUND.DATA_SOURCE = "2";
        }

        if (!_basicModule.CORP_ADDR.DEFAULT_VALUE && basicInfo.officeAddr) {
          _basicModule.CORP_ADDR.DEFAULT_VALUE = basicInfo.officeAddr;
          _basicModule.CORP_ADDR.DATA_SOURCE = "2";
        }
        if (!_basicModule.ID_ZIP_CODE.DEFAULT_VALUE && basicInfo.officePostCd) {
          _basicModule.ID_ZIP_CODE.DEFAULT_VALUE = basicInfo.officePostCd;
          _basicModule.ID_ZIP_CODE.DATA_SOURCE = "2";
        }
        if (basicInfo.fenNm) {
          if (_this.userType == "1") {
            if (!_this.oppBusiData.hideFields.ORG_ENGLISH_NAME) {
              _this.oppBusiData.hideFields.ORG_ENGLISH_NAME = {
                value: basicInfo.fenNm,
                DATA_SOURCE: "2"
              };
            }
          } else {
            if (!_this.oppBusiData.hideFields.PRO_MANAGER_ENNAME) {
              _this.oppBusiData.hideFields.PRO_MANAGER_ENNAME = {
                value: basicInfo.fenNm,
                DATA_SOURCE: "2"
              };
            }
          }
        }
        if (!_fieldData.ID_ADDR.DEFAULT_VALUE && basicInfo.regAddr) {
          _fieldData.ID_ADDR.DEFAULT_VALUE = basicInfo.regAddr;
          _fieldData.ID_ADDR.DATA_SOURCE = "2";
        }
        if (!_basicModule.CITIZENSHIP.DEFAULT_VALUE && basicInfo.country) {
          _basicModule.CITIZENSHIP.DEFAULT_VALUE = basicInfo.country;
          _basicModule.CITIZENSHIP.DATA_SOURCE = "2";
        }
        if (!linkModule.EMAIL.DEFAULT_VALUE && basicInfo.companyEm) {
          linkModule.EMAIL.DEFAULT_VALUE = basicInfo.companyEm;
          linkModule.EMAIL.DATA_SOURCE = "2";
        }
        if (!linkModule.OFFICE_TEL.DEFAULT_VALUE && basicInfo.companyPh) {
          linkModule.OFFICE_TEL.DEFAULT_VALUE = basicInfo.companyPh;
          linkModule.OFFICE_TEL.DATA_SOURCE = "2";
        }
      }
    }
  },
  getApptStatusText: function getApptStatusText(apptStatus) {
    if (!apptStatus) {
      apptStatus = vm.$store.state.apptStatus;
    }
    return dict.transformDict({ APPT_STATUS: apptStatus }, [{ "APPT_STATUS": "FXC_STATUS" }]).then(function (obj) {
      return obj.APPT_STATUS_TEXT;
    });
  },

  validateLegalTel: function validateLegalTel(_this, moduleObj) {
    var flag = true;
    if (!moduleObj.LEGAL_MOBILE_TEL.DEFAULT_VALUE && !moduleObj.LEGAL_PERSON_TEL.DEFAULT_VALUE) {
      _this.alert({
        messageText: "法定代表人/执行事务合伙人移动电话、固定电话不能同时为空！"
      });
      return false;
    }
    return flag;
  }
};
var plugin = {
  install: function install(Vue) {
    Vue.lbm = bizPublicMethod;

    Vue.prototype.$blMethod = bizPublicMethod;
  },

  $blMethod: bizPublicMethod
};

export default plugin;
export var install = plugin.install;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessTools/bizPublicMethod.js
// module id = 1619
// module chunks = 2